// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  label: {
    openMethod: 'mở đường',
    customer: 'Khách',
    supplier: 'Nguồn',
    ThisItemIsRequired: 'Mục này cần thiết',
    PleaseSelectSynchronizationBusinessType: 'Hãy chọn kiểu kinh doanh đồng bộ',
    PleaseSelectModificationStartDate: 'Vui lòng chọn ngày khởi động sửa đổi',
    PleaseSelectModificationEndDate: 'Vui lòng chọn ngày cuối sửa đổi',
    head: 'Tựa',
    pleaseEnterHead: 'Hãy nhập một tựa đề',
    messageType: 'Kiểu thông điệp',
    notificationType: 'Kiểu thông báo',
    pleaseChooseNotificationType: 'Hãy chọn kiểu thông báo',
    pleaseChooseMessageType: 'Hãy chọn kiểu tin nhắn',
    publisher: 'Nhà',
    designatedUser: 'Người dùng tên',
    pleaseChooseDesignatedUser: 'Hãy chọn người dùng đã xác định',
    allUser: 'Mọi người dùng',
    notice: 'Thông báo',//通知公告
    systemMessage: 'Thông điệp hệ thống',//系统消息
    low: 'thấp',//低
    middle: 'vào',//中
    high: 'cao',//高
    abstract: 'trừu tượng',
    pleaseEnterAbstract: 'Xin hãy nhập vào hồ sơ',
    priority: 'Ưu tiên',
    content: 'nội dung',
    pleaseChoosePriority: 'Hãy chọn mục tiêu',
    notificationObject: 'Mục thông báo',
    releaseStatus: 'Trạng thái giải phóng',
    releaseTime: 'Thời gian buông',
    startTime: 'giờ khởi chạy',
    pleaseChooseStartTime: 'Hãy chọn giờ khởi động',
    endTime: 'Hết giờ',
    pleaseChooseEndTime: 'Hãy chọn thời gian kết thúc',
    cancellationTime: 'Khoảng thời gian hủy',
    factory: '工厂',//工厂
    businessPartners: 'Đối tác nghiệp vụ',//业务伙伴
    serialNo: '序号',//序号
    pleaseEnterSerialNo: '请输入序号',//请输入序号
    periodCode: '期间代码',//期间代码
    pleaseEnterPeriodCode: '请输入期间代码',//请输入期间代码
    startDate: '开始日期', // 开始日期
    pleaseSelectStartDate: '请选择开始日期',//请选择开始日期
    endDate: '结束日期', // 结束日期
    pleaseSelectEndDate: '请选择结束日期',//请选择结束日期
    lockedStatus: '锁定状态', // 锁定状态
    company: 'Công ty',//公司
    pleaseSelectCompany: 'Chọn công ty',//请选择公司
    PeriodCode: '账期',//账期
    alreadySelect: '已选越南语',//已选
    pleaseSelectPeriod: '请选择账期',//请选择账期
    pleaseEnterPeriod: '请输入账期代码',//请输入账期
    pleaseSelectType: '请选择类型',//请选择类型
    isProductionCost: '是否生产成本',//是否生产成本
    details: '明细',//明细
    serviceDepartmentOrFarm: '服务部或农场',//服务部或农场
    pleaseSelectServiceDepartmentOrFarm: 'Chọn bộ phận dịch vụ hoặc trang trại',//请选择服务部或农场
    documentDate: 'Ngày chứng từ',//单据日期
    pleaseSelectDocumentDate: 'Chọn ngày lập phiếu',//请选择单据日期
    documentType: 'Loại chứng từ',//单据类型
    pleaseSelectDocumentType: 'Chọn loại tài liệu',//请选择单据类型
    documentStatus: 'Trạng thái chứng từ',//单据状态
    pleaseSelectDocumentStatus: 'Tình trạng tài liệu',//请选择单据状态
    documentNumber: 'Số chứng từ',//单据编号
    enterTheDocumentNumberForFuzzyQuery: 'Nhập mã số phiếu tra cứu không cụ thể',//输入单据编号模糊查询
    warehouse: 'Kho',//仓库
    pleaseSelectWarehouse: 'Chọn kho hàng',//请选择仓库
    requestFormMode: 'Mẫu đơn đề nghị',//申请单模式
    pleaseSelectRequestFormMode: 'Chọn mẫu đăng ký',//请选择申请单模式
    sectionAssignmentCategory: 'Phân phối loại tài khoản',//科目分配类别
    pleaseSelectSectionAssignmentCategory: 'Xin mời chọn loại phân phối tài khoản',//请选择科目分配类别
    supplierCode: 'Mã nhà cung ứng',//供应商编码
    pleaseSelectSupplierCode: 'Chọn mã nhà cung cấp',//请选择供应商编码
    supplierName: 'Tên nhà cung ứng',//供应商名称
    pleaseEnterSupplierName: 'Nhập tên nhà cung cấp',//请输入供应商名称
    demandDate: 'Ngày yêu cầu',//需求日期
    pleaseSelectTheDemandDate: 'Chọn ngày yêu cầu',//请选择需求日期
    requestedArrivalDate: 'Thời gian kiến nghị nhận hàng',//要求到货日期
    pleaseSelectRequestedArrivalDate: 'Vui lòng chọn ngày đến được yêu cầu',//请选择要求到货日期
    requisitioner: 'Người xin（申请人）',//请购员
    pleaseSelectRequisitioner: 'Hãy điền tên',//请选择请购员
    billingDate: 'Ngày chứng từ',//单据日期
    pleaseSelectTheBillDate: 'Chọn thời hạn thanh toán',//请选择单据账期
    remarks: 'Ghi chú',//备注
    pleaseEnterANote: 'Mời nhập ghi chú',//请输入备注
    contractCode: 'số đơn hợp đồng',//合同编码
    pleaseEnterTheContractCode: 'Nhập mã hợp đồng',//请输入合同编码
    billingStatus: 'Loại chứng từ',//单据类型
    pleaseSelectBillingStatus: 'Chọn loại tài liệu',//请选择单据类型
    receiptNumber: 'Nhập kho&mã số nhập kho',//入库单号
    enterTheIncomingBillNumberToFuzzySearch: 'Tra cứu bằng cách nhập số',//输入入库单号模糊查询
    inboundWarehouse: 'Kho nhận hàng',//入库仓库
    warehouseLocation: 'Vị trí kho',//库位
    purchaseContractNumber: 'Số hợp đồng thu mua',//采购合同号
    pleaseEnterThePurchaseContractNumber: 'Nhập số hợp đồng mua hàng',//请输入采购合同号
    postingDate: 'Ngày vào sổ',//过账日期
    pleaseSelectTheDateOfPosting: 'Vui lòng chọn ngày sang sổ',//请选择过账日期
    licensePlateNumber: 'Biển số xe',//车牌号
    pleaseEnterTheLicensePlateNumber: 'Nhập biển số xe',//请输入车牌号
    orderNumber: 'Mã Số đơn đặt hàng',//订单编号
    pleaseEnterOrderNumber: 'Nhập mã số đơn đặt hàng',//请输入订单编号
    farm: 'Nông trại',//农场
    pleaseSelectFarm: 'Chọn trang trại',//请选择农场
    transferOutFarm: 'Trại chuyển đi',//转出农场
    pleaseSelectTransferOutFarm: 'Chọn chuyển ra khỏi trang trại',//请选择转出农场
    customerCode: 'Mã khách hàng',//客户编码
    pleaseSelectTheCustomerCode: 'Xin mời chọn mã khách hàng',//请选择客户编码
    customerName: 'Tên khách hàng',//客户名称
    pleaseEnterTheCustomerName: 'Nhập tên khách hàng.',//请输入客户名称
    transferToFarm: 'Trại chuyển đến',//转入农场
    pleaseSelectTheFarmToBeTransferredTo: 'Chọn chuyển đến trang trại',//请选择转入农场
    requestedDateOfShipment: 'Ngày yêu cầu cấp hàng',//要求发货日期
    pleaseSelectTheRequestedDateOfShipment: 'Vui lòng điền ngày giao hàng được yêu cầu',//请选择要求发货日期
    salesman: 'Nhân viên bán hàng.',//销售员
    outgoingFarm: 'Trại xuất kho',//出库农场
    pleaseSelectTheOutgoingFarm: '请选择出库农场',//请选择出库农场
    inboundFarm: 'Nhập kho trang trại',//入库农场
    building: 'Chuồng',//栋舍
    pleaseSelectBuilding: 'Xin mời chọn ô chuồng',//请选择栋舍
    feedingLot: 'Số lứa chăn nuôi',//饲养批次
    pleaseEnterTheFeedingLot: 'Xin mời nhập lô chăn nuôi',//请输入饲养批次
    pleaseSelectTheFeedingLot: 'Xin mời chọn lô chăn nuôi',//请选择饲养批次
    typeOfDeparture: 'Loại hình xuất kho',//出库类型
    pleaseSelectTheTypeOfDeparture: 'Xin mời chọn loại hình xuất kho',//请选择出库类型
    dateOfRelease: 'Ngày xuất kho',//出库日期
    pleaseSelectTheDateOfShipment: 'Chọn ngày xuất kho',//请选择出库日期
    pleaseClickToSelectADepartment: 'Bấm chọn bộ phận',//请点击选择部门
    storageType: 'Loại hình nhập kho',//入库类型
    pleaseSelectTheTypeOfStorage: 'Chọn loại hình nhập kho',//请选择入库类型
    dateOfStorage: 'Thời gian nhập kho',//入库日期
    pleaseSelectTheDateOfStorage: 'Chọn ngày nhập kho',//请选择入库日期
    transferOutFarmServiceDepartment: '转出农场/服务部',//转出农场/服务部
    pleaseSelectTransferringFarmService: '请选择转出农场/服务部',//请选择转出农场/服务部
    transferToFarmService: '转入农场/服务部',//转入农场/服务部
    pleaseSelectTheFarmServiceDepartmentToWhichYouAreTransferring: '请选择转入农场/服务部',//请选择转入农场/服务部
    dateOfTransfer: 'Ngày phân bổ',//调拨日期
    pleaseSelectTheDateOfTransfer: 'Chọn ngày chuyển',//请选择调拨日期
    breed: 'Chủng loại',//品种
    pleaseEnterTheBreed: 'Nhập chủng loại',//请输入品种
    pleaseSelectTheBreed: 'Chọn giống',//请选择品种
    status: 'Trạng thái',//状态
    pleaseSelectStatus: 'Vui lòng điền trạng thái',//请选择状态
    batchNumber: 'Số phê chuẩn',//批号
    pleaseEnterTheBatchNumber: 'Nhập số lô',//请输入批号
    productionBatchNumber: 'Số lô tổn thất',//生产批次编号
    pleaseEnterTheProductionBatchNumber: 'Xin mời nhập số hiệu lô sản xuất',//请输入生产批次编号
    theFirstAndLastBitOfTheBatchNumberIsNotAllowedToBeSpace: 'Vị trí đầu tiên và cuối cùng số hiệu lô không được để trồng',//批次编号首末位不允许为空格
    flockName: 'Tên lô',//批次名称
    pleaseEnterTheFlockName: 'Nhập tên lứa nuôi',//请输入批次名称
    settlementBatchNumber: '结算批次编号',//结算批次编号
    pleaseEnterTheSettlementBatchNumber: 'Nhập mã số lứa quyết toán',//请输入结算批次编号
    TheBatchNumberIsLimitedTo8Digits: 'Số hiệu lô hạn chế chỉ 8 số',//批次编号限制8位
    placementAge: 'Ngày tuổi nhập chuồng',//入舍日龄
    pleaseEnterTheStartingAge: 'Xin mời nhập ngày tuổi bắt đầu',//请输入起始日龄
    category: 'Chủng loại sản phẩm',//品类
    pleaseSelectCategory: 'Chọn chủng loại',//请选择品类
    generation: 'Thế hệ',//代次
    pleaseSelectGeneration: 'Chọn thế hệ',//请选择代次
    breedingType: 'Loại hình chăn nuôi',//养殖类型
    pleaseSelectBreedingType: 'Chọn loại hình chăn nuôi',//请选择养殖类型
    startTimeOfVaccination: '防疫开始时间',//防疫开始时间
    pleaseSelectTheStartTimeOfVaccination: 'Chọn thời gian bắt đầu phòng chống dịch',//请选择防疫开始时间
    plannedNumberOfHouses: 'Kế hoạch số lượng vào chuồng',//计划入舍数量
    pleaseEnterThePlannedNumberOfHouses: 'Nhập kế hoạch số lượng nhập chuồng',//请输入计划入舍数量
    plannedDateOfArrival: 'Kế hoạch ngày vào chuồng',//计划入舍日期
    pleaseSelectThePlannedArrivalDate: 'Vui lòng chọn ngày dự kiến nhập chuồng',//请选择计划入舍日期
    plannedTransferDate: 'Ngày chuyển đổi dự kiến',//计划转场日期
    pleaseSelectThePlanTransferDate: 'Vui lòng chọn ngày dự kiến chuyển trại',//请选择计划转场日期
    planPriceConfirmationDate: 'Ngày xác định giá trị kế hoạch',//计划身价确认日期
    pleaseSelectThePlannedPriceConfirmationDate: 'Vui lòng chọn ngày dự kiến xác nhận giá trị ban đầu ( định chuồng)',//请选择计划身价确认（定栏）日期
    plannedCullDate: 'Kế hoạch ngày loại thải',//计划淘汰日期
    pleaseSelectThePlannedEliminationDate: 'Vui lòng chọn ngày dự kiến đào thải',//请选择计划淘汰日期
    breedingMethod: 'Hình thức chăn nuôi',//养殖方式
    pleaseSelectBreedingMethod: 'Chọn loại hình chăn nuôi',//请选择养殖方式
    breeder: 'Nhân viên chăn nuôi',//饲养员
    pleaseSelectBreeder: 'Xin mời chọn nhân viên chăn nuôi',//请选择饲养员
    batchType: 'Loại lô',//批次类型
    emptyDate: 'Ngày trống chuồng',//空舍日期
    pleaseSelectTheDateOfEmptying: 'Xin mời chọn ngày để trống chuồng',//请选择空舍日期
    vaccinationStartDate: 'Ngày bắt đầu phòng chống dịch',//防疫开始日期
    pleaseSelectTheStartDateOfVaccination: 'Chọn thời gian bắt đầu phòng chống dịch',//请选择防疫开始时间
    DaysOfAge127: '127 ngày tuổi',//127日龄日期
    currentAge: 'Ngày tuổi hiện tại',//当前日龄
    pleaseFillInTheCurrentAge: 'Điền vào ngày tuổi hiện tại',//请填写当前日龄
    parentBatchNumber: 'Số lô chính',//父级批次编号
    pleaseFillInTheParentBatchNumber: 'Mời nhập mã số lô gốc',//请填写父级批次编号
    preFeatheringAge: 'Tuổi trước khi thay',//换羽前日龄
    pleaseFillInTheAgeBeforeFledge: 'Điền tuổi trước khi thay lông',//请填写换羽前日龄
    priceFixingDate: 'Ngày xác định giá ban đầu',//身价确定日期
    pleaseSelectTheDateOfPriceDetermination: 'Vui lòng chọn ngày để xác nhận giá trị',//请选择身价确定日期
    priceDeterminationInventory: 'Xác định số lượng tồn ban đầu',//身价确定存栏
    pleaseFillInThePriceDeterminationField: 'Xin mời nhập giá trị xác định số lượng tồn',//请填写身价确定存栏
    originalValue: 'Xác định giá trị ban đầu',//身价确定原值
    pleaseFillInThePriceDeterminationOriginalValue: 'Xin mời nhập nguyên giá xác định ban đầu',//请填写身价确定原值
    singleSalvageValue: 'Giá trị còn lại',//单只残值
    pleaseFillInTheSingleSalvageValue: 'Điền giá trị số lượng còn lại',//请填写单只残值
    batchResidualValue: 'Giá trị còn lại theo lô',//批次残值
    pleaseFillInTheLotResidualValue: 'Điền giá trị còn lại theo lô',//请填写批次残值
    batchNetValue: 'Giá trị ròng của lô',//批次净值
    pleaseFillInTheBatchNetValue: '请填写批次净值',//请填写批次净值
    assessedAmount: 'Giá trị đã phân bổ',//已分摊金额
    pleaseFillInTheApportionedAmount: 'Xin mời nhập giá trị đã phân bổ',//请填写已分摊金额
    deadTransferOut: 'Chết/loại thải chuyển đi',//死淘转出
    pleaseFillInTheDeadAmalgamationTransferOut: 'Xin mời nhập số lượng chết/ đào thải chuyển đi',//请填写死淘转出
    totalMonthOfApportionment: 'Phân bổ tổng số tháng',//分摊总月份
    pleaseFillInTheTotalMonthOfApportionment: 'Điền tổng số tháng phân bổ',//请填写分摊总月份
    apportionedMonth: 'Tháng đã phân bổ',//已分摊月份
    pleaseFillInTheApportionedMonth: 'Xin mời nhập tháng đã phân bổ',//请填写已分摊月份
    remainingMonths: 'Số tháng còn lại cần phân bổ',//剩余分摊月份
    pleaseFillInTheRemainingMonths: 'Xin mời nhập tháng phân bổ còn lại',//请填写剩余分摊月份
    startPeriod: 'Bắt đầu giai đoạn phân bổ',//开始分摊期间
    pleaseFillInTheStartPeriod: 'Xin mời nhập thời gian bắt đầu phân bổ',//请填写开始分摊期间
    apportionedPeriod: 'Thời gian đã phân bổ',//已分摊期间
    pleaseFillInTheApportionedPeriod: 'Xin mời nhập thời gian đã phân bổ',//请填写已分摊期间
    nextApportionmentPeriod: 'Thời gian phân bổ lần sau',//下次分摊期间
    pleaseFillInTheNextApportionmentPeriod: 'Xin mời nhập kỳ phân bổ lần sau',//请填写下次分摊期间
    dateOfAcceptance: 'Ngày nghiệm thu',//验收日期
    pleaseSelectTheDateOfAcceptance: 'Xin mời chọn ngày nghiệm thu',//请选择验收日期
    receivingAndInspectionPersonnel: 'Nhân viên nghiệm thu',//验收人员
    pleaseSelectTheAcceptancePersonnel: 'Chọn nhân viên nghiệm thu',//请选择验收人员
    rejectedItem: 'Bị loại',//否决项
    pleaseEnterTheVetoItem: 'Nhập quyền',//请输入否决项
    judgingCriteria: 'Tiêu chuẩn đánh giá',//评判标准
    pleaseEnterTheJudgingCriteria: 'Xin mời nhập tiêu chuẩn đánh giá',//请输入评判标准
    conclusion: 'Kết luận',//结论
    pleaseSelectConclusion: 'Chọn kết luận',//请选择结论
    synchronizationStatus: 'Trạng thái đồng bộ',//同步状态
    pleaseSelectTheSynchronizationStatus: 'Chọn trạng thái đồng bộ hóa',//请选择同步状态
    dayAge: 'Ngày tuổi',//日龄
    pleaseEnterTheAgeOfTheDay: 'Nhập ngày tuổi',//请输入日龄
    weekAge: 'Tuần tuổi',//周龄
    pleaseEnterTheAgeOfTheWeek: 'Nhập tuần tuổi',//请输入周龄
    medicine: 'Thuốc, dược phẩm',//药品
    pleaseSelectMedicine: 'Vui lòng điền thuốc',//请选择药品
    materialName: 'Tên vật liệu',//物料名称
    pleaseEnterTheNameOfTheMaterial: 'Xin mời nhập tên vật tư',//请输入物料名称
    applicableScenario: 'Hoàn cảnh áp dụng',//适用场景
    pleaseSelectTheApplicableScenario: 'Chọn cách áp dụng',//请选择适用场景
    gender: 'Giới tính',//性别
    pleaseSelectGender: 'Chọn giới tính',//请选择性别
    documentInformation: 'Thông tin tài liệu',//单据信息
    pleaseSelectTheDocumentInformation: 'Chọn thông tin tài liệu',//请选择单据信息
    maximumIndoorTemperature: 'Nhiệt độ cao nhất trong phòng (℃)',//最高室内温度(℃)
    pleaseEnterTheHighestIndoorHumidity: 'Mời nhập độ ẩm lớn nhất trong phòng',//请输入最高室内湿度
    lowestIndoorTemperature: 'Nhiệt độ thấp nhất trong phòng (℃)',//最低室内温度(℃)
    pleaseEnterTheMinimumIndoorTemperature: 'Mời nhập nhiệt độ thấp nhất trong phòng',//请输入最低室内温度
    maximumOutdoorTemperature: 'Nhiệt độ ngoài trời cao nhất ( ℃)',//最高室外温度(℃)
    pleaseInputTheMaximumOutdoorTemperature: 'Mời nhập nhiệt độ lớn nhất ngoài trời',//请输入最高室外温度
    lowestOutdoorTemperature: 'Nhiệt độ ngoài trời thấp nhất (℃)',//最低室外温度(℃)
    pleaseInputTheLowestOutdoorTemperature: 'Mời nhập nhiệt độ ngoài trời thấp nhất',//请输入最低室外温度
    maximumBodyTemperature: 'Nhiệt độ cơ thể cao nhất (℃)',//体感最高温度(℃)
    pleaseInputTheMaximumBodyTemperature: 'Xin mời nhập nhiệt độ cao nhất',//请输入体感最高温度
    minimumTemperature: 'Nhiệt độ cơ thể thấp nhất (℃)',//体感最低温度(℃)
    pleaseInputTheLowestBodyTemperature: 'Xin mời nhập nhiệt độ thấp nhất',//请输入体感最低温度
    highestIndoorHumidity: 'Độ ẩm cao nhất trong phòng (%)',//最高室内湿度(%)
    lowestIndoorHumidity: 'Độ ẩm thấp nhất trong phòng (%)',//最低室内湿度(%)
    pleaseEnterTheLowestIndoorHumidity: 'Mời nhập đổ ẩm thấp nhất trong phòng',//请输入最低室内湿度
    maximumOutdoorHumidity: 'Độ ẩm ngoài trời lớn nhất (%)',//最高室外湿度(%)
    pleaseEnterTheMaximumOutdoorHumidity: 'Mời nhập độ ẩm lớn nhất ngoài trời',//请输入最高室外湿度
    minimumOutdoorHumidity: 'Độ ẩm thấp nhất ngoài trời (%)',//最低室外湿度(%)
    pleaseEnterTheMinimumOutdoorHumidity: 'Mời nhập độ ẩm ngoài trời thấp nhất',//请输入最低室外湿度
    maximumLightIntensity: 'Cường độ sáng ( lux)',//最大光照强度(Lux)
    pleaseEnterTheMaximumLightIntensity: 'Mời nhập cường độ chiếu sáng tối đa',//请输入最大光照强度
    minimumLightIntensity: 'Cường độ ánh sáng nhỏ nhất',//最小光照强度(Lux)
    pleaseEnterTheMinimumLightIntensity: 'Mời nhập cường độ chiếu sáng tối thiểu',//请输入最小光照强度
    durationOfLight: 'Khoảng thời gian chiếu sáng (h)',//光照时长(h)
    pleaseEnterTheDurationOfLight: 'Nhập thời gian chiếu sáng',//请输入光照时长
    carbonDioxideConcentration: 'Nồng độ Cac-bon đi-ô-xit(%)',//二氧化碳浓度(%)
    pleaseEnterTheCarbonDioxideConcentration: 'Nhập nồng độ Cac-bon đi-ô-xit',//请输入二氧化碳浓度
    maxVentilationCoefficient: 'Hệ số thông gió tối đa',//最大通风系数
    pleaseEnterTheMaximumVentilationFactor: 'Mời nhập hệ số thông gió tối đa',//请输入最大通风系数
    minimumVentilationFactor: 'Hệ số thông gió tối thiểu',//最小通风系数
    pleaseEnterTheMinimumVentilationFactor: 'Mời nhập hệ số thông gió tối thiểu',//请输入最小通风系数
    waterConsumption: 'Lượng nước tiêu thụ( lít)',//耗水量(升)
    pleaseInputWaterConsumption: 'Nhập mức tiêu thụ nước',//请输入耗水量
    electricityConsumption: 'Mức tiêu thụ năng lượng',//耗电量
    pleaseInputPowerConsumption: 'Nhập mức tiêu thụ điện',//请输入耗电量
    fuelType: 'Loại nhiên liệu',//燃料类型
    fuelConsumption: 'Tiêu thụ xăng dầu',//燃料消耗量
    pleaseInputFuelConsumption: 'Xin mời nhập lượng tiêu hao nhiên liệu',//请输入燃料消耗量
    cageUniformity: 'Tính đồng nhất ( %)',//笼位均匀度(%)
    pleaseInputTheNumberOfCageUniformity: 'Nhập số lồng bình quân',//请输入笼位均匀数
    maximumIndoorTemperatureMustNotBeLessThanTheMinimumIndoorTemperature: 'Nhiệt độ cao nhất trong phòng không được nhỏ hơn nhiệt độ thấp nhất trong phòng',//最高室内温度不能小于最低室内温度
    maximumIndoorTemperatureMustBeLessThanTwoDecimalPlaces: 'Nhiệt độ trong phòng cao nhất bắt buộc ít hơn hai chữ số thập phân',//最高室内温度必须少于两位小数
    minimumIndoorTemperatureCannotBeGreaterThanTheMaximumIndoorTemperature: 'Nhiệt độ thấp nhất trong phòng không được lớn hơn nhiệt độ cao nhất trong phòng',//最低室内温度不能大于最高室内温度
    minimumIndoorTemperatureMustBeLessThanTwoDecimalPlaces: 'Nhiệt độ thấp nhất trong phòng bắt buộc nhỏ hơn hai chữ số thập phân',//最低室内温度必须少于两位小数
    theMaximumOutdoorTemperatureCannotBeLessThanTheMinimumOutdoorTemperature: 'Nhiệt độ ngoài trời cao nhất không nhỏ hơn nhiệt độ ngoài trời thấp nhất',//最高室外温度不能小于最低室外温度
    theMaximumOutdoorTemperatureMustBeLessThanTwoDecimalPlaces: 'Nhiệt độ ngoài trời cao nhất bắt buộc ít hơn hai chữ số thập phân',//最高室外温度必须少于两位小数
    theMinimumOutdoorTemperatureCannotBeGreaterThanTheMaximumOutdoorTemperature: 'Nhiệt độ ngoài trời thấp nhất không được cao hơn nhiệt độ ngoài trời cao nhất',//最低室外温度不能大于最高室外温度
    theMinimumOutdoorTemperatureMustBeLessThanTwoDecimalPlaces: 'Nhiệt độ ngoài trời thấp nhất bắt buộc nhỏ hơn hai chữ số thập phân',//最低室外温度必须少于两位小数
    theMaximumBodyTemperatureMustNotBeLessThanTheMinimumBodyTemperature: 'Nhiệt độ cơ thể lớn nhất không được nhỏ hơn nhiệt độ cơ thể thấp nhất',//最高体感温度不能小于最低体感温度
    theMaximumBodyTemperatureMustBeLessThanTwoDecimalPlaces: 'Nhiệt độ cơ thể lớn nhất bắt buộc ít hơn 2 chữ số thập phân',//最高体感温度必须少于两位小数
    theMinimumBodyTemperatureMustNotBeGreaterThanTheMaximumBodyTemperature: 'Nhiệt độ thân nhiệt thấp nhất không được lớn hơn nhiệt độ thân nhiệt cao nhất',//最低体感温度不能大于最高体感温度
    theMinimumBodyTemperatureMustBeLessThanTwoDecimalPlaces: 'Nhiệt độ thân nhiệt thấp nhất bắt buộc ít hơn hai chữ số thập phân',//最低体感温度必须少于两位小数
    theMaximumIndoorHumidityCannotBeLessThanTheMinimumIndoorHumidity: 'Độ ẩm cao nhất trong phòng không được nhỏ hơn độ ẩm thấp nhất trong phòng',//最高室内湿度不能小于最低室内湿度
    maximumIndoorHumidityMustBeLessThanTwoDecimalPlaces: 'Độ ẩm cao nhất trong phòng bắt buộc nhỏ hơn hai chữ số thập phân',//最高室内湿度必须少于两位小数
    theMinimumIndoorHumidityCannotBeGreaterThanTheMaximumIndoorHumidity: 'Độ ẩm thấp nhất trong phòng không được lớn hơn độ ẩm cao nhất trong phòng',//最低室内湿度不能大于最高室内湿度
    minimumIndoorHumidityMustBeLessThanTwoDecimalPlaces: 'Độ ẩm thấp nhất trong phòng bắt buộc ít hơn hai chữ số thập phân',//最低室内湿度必须少于两位小数
    theMaximumOutdoorHumidityMustNotBeLessThanTheMinimumOutdoorHumidity: 'Độ ẩm ngoài trời cao nhất không được nhỏ hơn độ ẩm ngoài trời thấp nhất',//最高室外湿度不能小于最低室外湿度
    maximumOutdoorHumidityMustBeLessThanTwoDecimalPlaces: 'Độ ẩm ngoài trời cao nhất bắt buộc ít hơn hai chữ số thập phân',//最高室外湿度必须少于两位小数
    theMinimumOutdoorHumidityCannotBeGreaterThanTheMaximumOutdoorHumidity: 'Độ ẩm ngoài trời thấp nhất không được lớn hơn độ ẩm ngoài trời cao nhất',//最低室外湿度不能大于最高室外湿度
    minimumOutdoorHumidityMustBeLessThanTwoDecimalPlaces: 'Độ ẩm ngoài trời thấp nhất bắt buộc ít hơn hai chữ số thập phân',//最低室外湿度必须少于两位小数
    theMaximumVentilationCoefficientMustNotBeLessThanTheMinimumVentilationCoefficient: 'Hệ số thông gió tối đa không được nhỏ hơn hệ số thông gió tối thiểu',//最大通风系数不能小于最小通风系数
    maximumVentilationCoefficientMustBeGreaterThanOrEqualTo: 'Hệ số thông gió tối đa phải lớn hơn hoặc bằng 0',//最大通风系数必须大于等于0
    maximumVentilationCoefficientMustBeLessThanTwoDecimalPlaces: 'Hệ số thông gió tối đa phải ít hơn hai chữ số thập phân',//最大通风系数必须少于两位小数
    theMinimumVentilationCoefficientCannotBeGreaterThanTheMaximumVentilationCoefficient: 'Hệ số thông gió tối thiểu không được lớn hơn hệ số thông gió tối đa',//最小通风系数不能大于最大通风系数
    minimumVentilationCoefficientMustBeGreaterThanOrEqualTo: 'Hệ số thông gió nhỏ nhất phải lớn hơn hoặc bằng 0',//最小通风系数必须大于等于0
    minimumVentilationCoefficientMustBeLessThanTwoDecimalPlaces: 'Hệ số thông gió nhỏ nhất phải nhỏ hơn hai chữ số thập phân',//最小通风系数必须少于两位小数
    waterConsumptionMustBeGreaterThanOrEqualTo: 'Lượng nước tiêu thụ lớn hơn hoặc bằng 0',//耗水量必须大于等于0
    waterConsumptionMustBeLessThanTwoDecimalPlaces: 'Lượng nước tiêu thụ nhỏ hơn 2 chữ số thập phân',//耗水量必须少于两位小数
    powerConsumptionMustBeGreaterThanOrEqualTo: 'Mức tiêu thụ năng lượng lớn hơn hoặc bằng 0',//耗电量必须大于等于0
    powerConsumptionMustBeLessThanTwoDecimalPlaces: 'Mức tiêu thụ năng lượng lớn hơn 2 chứ số thập phân',//耗电量必须少于两位小数
    theMaximumLightIntensityMustNotBeLessThanTheMinimumLightIntensity: 'Cường độ ánh sáng tối đa không được lớn hơn cường độ ánh sáng tối thiểu',//最大光照强度不能小于最小光照强度
    maximumLightIntensityMustBeLessThanTwoDecimalPlaces: 'Cường độ ánh sáng phải nhỏ hơn 2 chữ số thập phân',//最大光照强度必须少于两位小数
    theMinimumLightIntensityMustNotBeGreaterThanTheMaximumLightIntensity: 'Cường độ ánh sáng tối thiểu không được lớn hơn cường độ ánh sáng tối đa',//最小光照强度不能大于最大光照强度
    minimumLightIntensityMustBeLessThanTwoDecimalPlaces: 'Cường độ ánh sáng tối thiểu phải nhỏ hơn hai chữ số thập phân',//最小光照强度必须少于两位小数
    theDurationOfLightMustBeGreaterThanOrEqualTo: 'Thời gian chiếu sáng phải lớn hơn hoặc bằng 0',//光照时长必须大于等于0
    theDurationOfLightMustBeLessThanTwoDecimalPlaces: 'Thời gian chiếu sáng phải lớn hơn 2 chữ số thập phân',//光照时长必须少于两位小数
    carbonDioxideConcentrationMustBeGreaterThanOrEqualTo: '二氧化碳浓度必须大于等于0',//二氧化碳浓度必须大于等于0
    carbonDioxideConcentrationMustBeLessThanTwoDecimalPlaces: '二氧化碳浓度必须少于两位小数',//二氧化碳浓度必须少于两位小数
    fuelConsumptionMustBeGreaterThanOrEqualTo: 'Lượng tiêu hao nhiên liệu phải lớn hơn hoặc bằng 0',//燃料消耗量必须大于等于0
    fuelConsumptionMustBeLessThanTwoDecimalPlaces: 'Lượng tiêu hao nhiên liệu bắt buộc phải ít hơn hai chữ số thập phân',//燃料消耗量必须少于两位小数
    cageUniformityMustBeGreaterThan: 'Số lồng trung bình phải lớn hơn 0',//笼位均匀数必须大于0
    cageUniformityMustBeLessThanTwoDecimalPlaces: 'Số lồng bình quân bắt buộc ít hơn 2 số thập phân',//笼位均匀数必须少于两位小数
    average: 'Giá trị bình quân',//平均值
    pleaseEnterTheAverageValue: 'Nhập giá trị trung bình',//请输入平均值
    pleaseAddDetails: 'Nhập thông tin chi tiết',//请添加明细
    upperLimit: 'Giới hạn trên',//上限
    lowerLimit: 'Giới hạn dưới',//下限
    uniformity: 'Ngang nhau',//均匀度(%)
    submittedBy: 'Người cung cấp',//提报人
    pleaseSelectTheSubmitter: 'Chọn người báo cáo',//请选择提报人
    testingAge: 'Tuổi xét nghiệm',//检测日龄
    pleaseInputTheTestingAge: 'Xin mời nhập ngày tuổi kiểm dịch',//请输入检测日龄
    sample: 'Hàng mẫu',//样品
    pleaseSelectSample: 'Vui lòng điền mẫu',//请选择样品
    item: 'Dự án',//项目
    pleaseSelectTheItem: 'Chọn dự án',//请选择项目
    testPerson: 'Nhân viên xét nghiệm',//检测人员
    pleaseSelectAcceptancePersonnel: 'Chọn người thanh tra',//请选择检测人员
    testDate: 'Ngày xét nghiệm',//检测日期
    pleaseSelectTheDateOfTesting: 'Chọn ngày thanh tra',//请选择检测日期
    coefficientOfVariation: 'Hệ số biến thiên',//变异系数
    cullingLoss: 'Hao hụt thải',//淘汰损失
    totalNumberOfLivestock: 'Tổng đàn gia súc, gia cầm',//畜禽总数量
    numberOfSickHouses: 'Số chuồng phát bệnh',//发病舍数量
    deathLoss: 'Hao hụt chết',//死亡损失
    ageAtDiseaseOnset: 'Tuổi phát bệnh',//发病日龄
    productionLoss: 'Tổn thất sản xuất',//生产损失
    dateOfDiseaseOnset: 'Ngày phát bệnh',//发病日期
    pleaseSelectDateOfOnset: 'Chọn ngày phát bệnh',//请选择发病日期
    dateOfRecovery: 'Ngày khôi phục',//痊愈日期
    pleaseSelectTheDateOfRecovery: 'Chọn ngày khôi phục',//请选择痊愈日期
    testingCost: 'Chi phí xét nghiệm',//检测费用
    numberOfCases: 'Số phát bệnh',//发病数
    incidenceRate: 'Tỷ lệ mắc bệnh',//发病率
    treatmentCost: 'Chi phí thuốc men',//治疗费用
    numberOfCulling: '淘汰数',//淘汰数
    cullingRate: 'Tỷ lệ thải',//淘汰率
    preventionCosts: 'Chi phí phòng ngừa',//预防费用
    numberOfDeaths: '死亡数',//死亡数
    mortalityRate: 'Tỉ lệ tử vong',//死亡率
    otherCosts: 'Lệ phí khác',//其它费用
    productionPerformance: 'Tính năng sản xuất',//生产性能
    diseaseCategory: 'Loại bệnh',//疾病类别
    totalLoss: 'Tổng thiệt hại',//损失合计
    prevalence: 'Mức độ phổ biến',//流行情况
    symptoms: 'Triệu chứng',//症状
    dissectingLesions: 'Chữa vết thương',//解刨病变
    detectionItemsAndResults: 'Các hạng mục xét nghiệm và kết quả',//检测项目及结果
    treatmentHistory: 'Xử lý',//处理经过
    diagnosisResults: 'Kết quả chẩn đoán',//诊断结果
    farmCode: 'Mã nông trại',//农场编码
    month: 'Tháng',//月份
    pleaseSelectTheMonth: 'Vui lòng điền tháng',//请选择月份
    billMaker: 'Người lập phiếu',//制单人
    pleaseSelectThePersonWhoInvitesOrderMaking: 'Xin mời chọn người lập phiếu',//请选择请制单人
    numberOfPeopleOnTheRegister: 'Số người đăng kí',//在册人数
    pleaseEnterTheNumberOfPeopleOnTheRegister: 'Xin mời nhập số người trong sổ đăng ký',//请输入在册人数
    theNumberOfRegisteredPersonsMustBeAPositiveInteger: 'Số người đăng kí bắt buộc là số nguyên dương',//在册人数必须为正整数
    numberOfOutsideAssociates: 'Số lượng nhân viên thời vụ',//外协人数
    pleaseEnterTheNumberOfOutsideAssociates: 'Mời nhập số lượng nhân viên tài vụ',//请输入外协人数
    theNumberOfOutsourcedWorkersMustBeAPositiveInteger: 'Số lượng nhân viên thời vụ bắt buộc là số nguyên dương',//外协人数必须为正整数
    farmerCode: 'Mã số hộ chăn nuôi',//养户编码
    pleaseEnterTheFarmerCode: 'Nhập mã số trang trại',//请输入养户编码
    farmerName: 'Tên hộ chăn nuôi',//养户名称
    pleaseEnterTheFarmerName: 'Nhập tên trang trại',//请输入养户名称
    farmerType: 'Loại hình hộ chăn nuôi',//养户类型
    pleaseSelectTheTypeOfFarmer: 'Chọn loại hình trang trại',//请选择养户类型
    code: 'Mã số',//编码
    pleaseEnterTheCode: 'Nhập mã',//请输入编码
    name: 'Tên',//名称
    pleaseEnterTheName: 'Nhập tên',//请输入名称
    shortName: 'Viết tắt',//简称
    pleaseEnterTheShortName: 'Nhập tên gọi tắt',//请输入简称
    fosterFamilyType: 'Loại hình hộ chăn nuôi',//养户类型
    pleaseSelectTheTypeOfFarmer: 'Chọn loại hình trang trại',//请选择养户类型
    fosterName: 'Tên hộ chăn nuôi',//养户名称
    pleaseEnterTheNameOfTheAdopter: 'Nhập tên trang trại',//请输入养户名称
    taxpayerIdentificationNumber: 'Số xác định người nộp thuế',//纳税人识别号
    pleaseEnterTheTaxpayerIdentificationNumber: 'Nhập biệt hiệu người nộp thuế',//请输入纳税人识别
    idNumber: 'Số CMT',//身份证号
    pleaseEnterTheIdCardNumber: 'Nhập số ID',//请输入身份证号
    substituteMaintenanceDepartment: '代养部',//代养部
    serviceDepartment: 'Bộ phận dịch vụ',//服务部
    administrationArea: 'Khu vực hành chính',//行政管理片区
    pleaseEnterTheAdministrativeArea: 'Xin mời nhập vùng quản lý hành chính',//请输入行政管理片区
    technician: 'Kỹ thuật viên',//技术员
    pleaseEnterTechnician: 'Nhập nhân viên kỹ thuật',//请输入技术员
    supervisor: 'Lãnh đạo phụ trách',//分管领导
    pleaseEnterTheSupervisor: 'Nhập lãnh đạo phụ trách',//请输入分管领导
    isTheCompany: 'Có phải Công ty',//是否公司
    pleaseSelectWhetherItIsACompany: 'Xin mời chọn có phải Công ty không',//请选择是否公司
    whetherSelfemployedOrNot: 'Có phải hộ cá thể',//是否个体户
    yes: 'Là',//是
    no: 'Không',//否
    pleaseEnterWhetherSelfemployedOrNot: 'Xin mời nhập có phải hộ cá nhân',//请输入是否个体户
    longitude: 'Kinh độ',//经度
    pleaseEnterTheLongitude: 'Nhập kinh độ',//请输入经度
    latitude: 'Vĩ độ',//纬度
    pleaseEnterLatitude: 'Mời nhập vĩ độ',//请输入纬度
    feedingArea: 'Diện tích nuôi',//喂养面积
    pleaseInputFeedingArea: 'Nhập diện tích chăn nuôi',//请输入喂养面积
    breedingScale: 'Quy mô chăn nuôi',//养殖规模(只）
    pleaseEnterTheBreedingScale: 'Xin mời nhập quy mô chăn nuôi (con)',//请输入养殖规模(只）
    timeZone: 'Múi giờ',//时区
    pleaseInputTimeZone: 'Nhập mũi giờ',//请输入时区
    maximumRadius: 'Bán kính lớn nhất',//最大半径
    pleaseEnterTheMaximumRadius: 'Nhập bán kinh lớn nhất',//请输入最大半径
    distanceToCompanyKm: 'Khoảng cách số km từ công ty',//距离公司公里数
    pleaseEnterTheNumberOfKilometersFromTheCompany: 'Hãy nhập số km tới công ty',//请输入距离公司公里数
    breederStatus: 'Trạng thái hộ chăn nuôi',//养户状态
    pleaseSelectTheStatusOfTheBreeder: 'Xin mời chọn trạng thái hộ chăn nuôi',//请选择养户状态
    phoneNumber: 'Điện thoại',//电话
    pleaseEnterTelephone: 'Nhập số điện thoại',//请输入电话
    cellPhone: 'Di động',//手机
    pleaseEnterYourCellPhone: 'Nhập số điện thoại di động',//请输入手机
    eMail: 'Hộp thư',//邮箱
    pleaseEnterYourEmailAddress: 'Nhập hộp thư',//请输入邮箱
    contactPerson: 'Người liên hệ',//联系人
    pleaseEnterYourContactPerson: 'Nhập địa chỉ liên hệ',//请输入联系人
    weChat: 'Wechat',//微信
    pleaseInputWechat: 'Mời nhập wechat',//请输入微信
    QQ: 'Số QQ',//QQ
    pleaseEnterQQ: 'Nhập số QQ.',//请输入QQ
    spouseName: 'Tên vợ/chồng',//配偶姓名
    pleaseEnterYourSpouseName: 'Nhập tên vợ/ chồng',//请输入配偶姓名
    spouseCellPhone: 'Điện thoại vợ/chồng',//配偶手机
    pleaseEnterYourSpouseCellPhone: 'Nhập số điện thoại vợ/ chồng',//请输入配偶手机
    spouseIdNumber: 'Số ID trống/ mái',//配偶身份证号
    pleaseEnterYourSpouseIdNumber: 'Nhập số CMTND vợ/ chồng',//请输入配偶身份证号
    homeAddress: 'Địa chỉ nhà',//家庭地址
    pleaseEnterYourHomeAddress: 'Nhập địa chỉ nhà',//请输入家庭地址
    bankOfAccount: 'Tên của Ngân hàng',//开户银行
    pleaseInputTheBankOfAccount: 'Nhập tên ngân hàng mở tài khoản',//请输入开户银行
    bankAddress: 'Địa chỉ ngân hàng',//开户行地址
    pleaseEnterTheAddressOfYourBank: 'Nhập địa chỉ ngân hàng',//请输入开户行地址
    accountNumber: 'Tài khoản',//账号
    pleaseEnterTheAccountNumber: 'Nhập tên người dùng',//请输入账号
    accountName: 'Tên tài khoản ( chủ hộ )',//账户名（户主）
    pleaseEnterTheAccountName: 'Nhập tên tài khoản (Chủ hộ)',//请输入账户名（户主）
    accessDate: 'Ngày truy cập',//准入日期
    pleaseSelectTheAccessDate: 'Vui lòng điền ngày truy cập',//请选择准入日期
    expirationDate: 'Ngày kết thúc hiệu lực',//失效日期
    pleaseSelectExpirationDate: 'Chọn ngày hết hạn',//请选择失效日期
    affiliatedSupplier: 'Nhà cung cấp liên kết',//关联供应商
    affiliatedCustomer: 'Khách hàng liên kết',//关联客户
    country: 'Quốc gia',//国家
    pleaseSelectTheCountry: 'Chọn quốc gia',//请选择国家
    province: 'Tỉnh',//省份
    pleaseSelectTheProvince: 'Chọn tỉnh',//请选择省份
    cityPrefectureLevelCity: '市/地级市',//市/地级市
    pleaseSelectTheCityPrefectureLevelCity: '请选择市/地级市',//请选择市/地级市
    countyDistrict: '县/区',//县/区
    pleaseSelectTheCountyDistrict: '请选择县/区',//请选择县/区
    street: '乡镇/街道/社区',//乡镇/街道/社区
    pleaseEnterStreet: '请输入乡镇/街道/社区',//请输入乡镇/街道/社区
    address: 'Địa chỉ ( Đường, số nhà )',//地址(街道门牌号)
    pleaseEnterTheAddress: 'Nhập địa chỉ ( Đường, số nhà)',//请输入地址(街道门牌号)
    statusChangeTime: 'Thời gian thay đổi trạng thái',//状态改变时间
    pleaseSelectTheTimeOfStatusChange: 'Xin mời chọn thời gian trạng thái thay đổi',//请选择状态改变时间
    partnerType: 'Loại đối tác',//合作商类型
    pleaseSelectPartnerType: 'Chọn loại đối tác',//请选择合作商类型
    companyName: 'Tên công ty',//公司名称
    PleaseEnterTheCompanyName: 'Nhập tên công ty',//请输入公司名称
    partnerGrouping: 'Nhóm đối tác',//伙伴分组
    PleaseEnterThePartnerGrouping: 'Nhập nhóm đối tác',//请输入伙伴分组
    businessPartners: 'Đối tác nghiệp vụ',//业务伙伴
    superiorPartnerCode: 'Mã số đối tác cấp cao',//上级合作商编码
    pleaseEnterTheSuperiorPartnerCode: 'Xin mời nhập mã số đối tác cấp cao',//请输入上级合作商编码
    enterpriseType: 'Kiểu tầu:',//企业类型
    pleaseSelectTheTypeOfEnterprise: 'Chọn loại hình doanh nghiệp',//请选择企业类型
    enterpriseTypeName: 'Tên loại doanh nghiệp',//企业类型名称
    legalPerson: 'Người đại diện pháp luật',//法人
    pleaseEnterTheLegalPerson: 'Nhập pháp nhân',//请输入法人
    registeredAddress: 'Địa chỉ đăng ký',//注册地址
    pleaseEnterTheRegisteredAddress: 'Nhập địa chỉ đã đăng ký',//请输入注册地址
    registeredCapital: 'Vốn đăng kí ( vạn NDT)',//注册资金(万元)
    pleaseEnterTheRegisteredCapital: 'Xin mời nhập số vốn đăng ký (vạn tệ)',//请输入注册资金(万元)
    contactPhoneNumber: 'Điện thoại liên hệ',//联系电话
    pleaseEnterYourContactNumber: 'Nhập số điện thoại',//请输入联系电话
    email: 'Email',//电子邮箱
    pleaseEnterYourEmailAddress: 'Nhập email',//请输入电子邮箱
    taxpayerType: 'Đối tượng nộp thuế',//纳税人类型
    pleaseSelectTheTypeOfTaxpayer: 'Xin mời chon loại hình đối tượng nộp thuế',//请选择纳税人类型
    taxpayerTypeDescription: 'Miêu tả đối tượng nộp thuế',//纳税人类型描述
    taxpayerIdentificationNumberIDCcard: '纳税人识别号/身份证',//纳税人识别号/身份证
    pleaseEnterTheTaxpayerIdentificationNumberIDCard: '请输入纳税人识别号/身份证',//请输入纳税人识别号/身份证
    accountOpeningBank: 'Khách hàng mở tại ngân hàng',//开户行
    pleaseInputTheAccountOpeningBank: 'Nhập tên ngân hàng mở tài khoản',//请输入开户行
    accountOfTheBank: 'Tài khoản ngân hàng',//开户行账户
    pleaseEnterTheAccountOfTheBank: 'Xin mời nhập số tài khoản ngân hàng',//请输入开户行账户
    validity: 'Hiệu quả',//有效性
    pleaseSelectWhetherItIsValidOrNot: 'Xin mời chọn có hiệu quả không',//请选择是否有效
    materialCode: 'Mã vật liệu',//物料编码
    pleaseEnterTheMaterialCode: 'Xin mời nhập số hiệu vật tư',//请输入物料编码
    materialName: 'Tên vật liệu',//物料名称
    pleaseEnterTheMaterialName: 'Xin mời nhập tên vật tư',//请输入物料名称
    materialGroup: 'Nhóm vật liệu',//物料组
    pleaseSelectMaterialGroup: 'Chọn nhóm vật liệu',//请选择物料组
    specification: 'Quy cách',//规格
    pleaseEnterTheSpecification: 'Vui lòng nhập số hiệu quy cách',//请输入规格型号
    manufacturer: 'Xưởng sản xuất',//厂家
    pleaseEnterTheManufacturer: 'Xin mời nhập nhà sản xuất',//请输入生产厂家
    brand: 'Nhãn hiệu',//品牌
    pleaseInputTheBrand: 'Nhập thương hiệu/ nhãn hiệu',//请输入品牌
    level: 'Cấp độ',//级别
    pleaseSelectTheLevel: 'Chọn cấp độ',//请选择级别
    availableForSale: 'có thể bán',//可销售
    pleaseChooseWhetherYouCanSell: 'Xin mời chọn có thể tiêu thụ không',//请选择是否可销售
    inventoryManagement: 'Quản lý hàng tồn kho',//库存管理
    pleaseSelectWhetherInventoryManagement: 'Xin mời chọn có phải quản lý tồn kho không',//请选择是否库存管理
    inventoryUnit: 'Đơn vị tồn kho',//库存单位
    pleaseSelectTheInventoryUnit: 'Xin mời chọn đơn vị tồn kho',//请选择库存单位
    salesUnit: 'Đơn vị bán hàng',//销售单位
    shelfLife: 'Thời hạn sử dụng (ngày)',//保质期(天)
    pleaseEnterTheShelfLife: 'Nhập hạn sử dụng ( Ngày)',//请输入保质期(天)
    description: 'Mô tả',//描述
    pleaseEnterADescription: 'Nhập mô tả',//请输入描述
    materialGroupClassification: 'Phân loại nhóm vật liệu',//物料组分类
    pleaseSelectTheMaterialGroupClassification: 'Chọn nhóm phân loại vật liệu',//请选择物料组分类
    warehouseCode: 'Mã kho hàng',//仓库编码
    pleaseEnterTheWarehouseCode: 'Nhập mã kho',//请输入仓库编码
    warehouseName: 'Tên kho',//仓库名称
    pleaseEnterTheWarehouseName: 'Nhập tên kho',//请输入仓库名称
    ERPInventoryLocation: 'ERP库存地点',//ERP库存地点
    pleaseEnterTheERPInventoryLocation: 'Nhập vị trí lưu trữ ERP',//请输入ERP库存地点
    warehouseType: 'Loại lưu trữ',//仓储类型
    pleaseSelectTheWarehouseType: 'Xin mời chọn loại hình kho lưu trữ',//请选择仓储类型
    warehouseIdentification: 'Thẻ kho',//仓库标识
    pleaseSelectTheWarehouseIdentification: 'Chọn thẻ kho',//请选择仓库标识
    affiliatedWarehouse: 'Thuộc về kho',//所属仓库
    pleaseSelectTheAffiliatedWarehouse: 'Xin mời chọn thuộc về kho',//请选择所属仓库
    maximumCapacity: 'Sức chứa tối đa ( kg)',//最大容量(kg)
    pleaseEnterTheMaximumCapacity: 'Mời nhập sức chứa tối đa (kg)',//请输入最大容量(kg)
    organization: 'Chi nhánh',//所属机构
    pleaseClickToSelectOrganization: 'Bấm chọn chi nhánh',//请点击选择所属机构
    storageManagement: 'Quản lý kho hàng dự trữ',//库位管理
    defaultWarehouseLocation: 'Kho mặc định',//默认库位
    purchaseUnit: 'Đơn vị mua hàng',//采购单位
    pleaseSelectthePurchasingUnit: 'Xin mời chọn đơn vị thu mua',//请选择采购单位
    purchaseInventoryConversionRate: 'Mua - chuyển đổi cổ phiếu',//采购-库存换算率
    pleaseEnterTheConversionRate: 'Nhập tỷ lệ chuyển đổi',//请输入换算率
    whetherValid: 'Có hiệu quả không',//是否有效
    factory: '工厂',//工厂
    pleaseSelectFactory: 'Chọn nhà máy',//请选择工厂
    factoryCode: '工厂编码',//工厂编码
    pleaseSelectFactoryCode: 'Chọn mã nhà máy',//请选择工厂编码
    batchManagement: 'Quản lý lô',//批次管理
    convertibleMaterialName: 'Tên vật tư chuyển đổi',//可转换物料名称
    pleaseEnterTheNameOfTheConvertibleMaterial: 'Xin mời nhập tên vật tư chuyển đổi',//请输入可转换物料名称
    defaultVersion: 'Có mặc định phiên bản này không?',//是否默认版本
    standardType: 'Loại tiêu chuẩn',//标准类型
    whetherToDistinguishBetweenSexes: 'Có cần phân biệt giới tính?',//是否区分性别
    versionDescription: 'Mô tả bản in',//版本描述
    pleaseEnterTheVersionDescription: 'Nhập mô tả phiên bản',//请输入版本描述
    version: 'Bản in',//版本
    pleaseEnterTheVersion: 'Nhập phiên bản',//请输入版本
    type: 'Loại hình/ kiểu',//类型
    eggFCRDuringLayingPeriod: 'Tỷ lệ giữa thức ăn tiêu thụ và số lượng trứng được tạo ra trong thời kì sinh sản',//产蛋期料蛋比
    pleaseEnterTheEggFCRDuringTheEgglayingPeriod: 'Mời nhập tỉ lệ thức ăn/ trứng trong giai đoạn đẻ',//请输入产蛋期料蛋比
    totalUniformity: 'Đồng nhất quy trình',//全程均匀度
    pleaseEnterTheTotalUniformity: 'Xin mời nhập độ đồng đều toàn quá trình',//请输入全程均匀度
    breedingStrain: 'Quá tải',//品系
    pleaseSelectBreed: 'Chọn hệ giống',//请选择品系
    effectiveDate: 'Ngày có hiệu lực',//生效日期
    pleaseSelectEffectiveDate: 'Chọn ngày có hiệu lực',//请选择生效日期
    grower: 'Hộ chăn nuôi',//养户
    pleaseSelectGrower: 'Chọn trang trại',//请选择养户
    menuType: 'thực đơn',//菜单类型
    firstLevelMenu: 'Danh mục cấp một',//一级菜单
    submenu: 'Danh mục con',//子菜单
    buttonsPermissions: '按钮/权限',//按钮/权限
    pleaseEnterMenuName: 'Nhập thực đơn',//请输入菜单名称
    parentMenu: 'Danh mục cấp cao',//上级菜单
    pleaseSelectParentMenu: 'Chọn danh mục cấp cao',//请选择上级菜单
    menuPath: 'Hưỡng dẫn thực đơn',//菜单路径
    pleaseEnterTheMenuPath: 'Nhập',//请输入菜单路径
    frontComponents: 'Thành phần dao diện người dùng',//前端组件
    pleaseEnterFrontComponents: 'Nhập thành phần dao diện người dùng',//请输入前端组件
    defaultJumpAddress: 'Địa chỉ điều chuyển mặc định',//默认跳转地址
    pleaseEnterRouterRedirect: 'Nhập tham số định tuyến redirect',//请输入路由参数 redirect
    authorizationID: 'ID ủy quyền',//授权标识
    pleaseEnterAuthorization: '请输入授权标识，如: user:list',//请输入授权标识，如: user:list
    authorizationPolicy: 'Chiến lược ủy quyền',//授权策略
    pleaseSelectAuthorizationPolicy: 'Chọn chiến lược ủy quyền',//请选择授权策略
    menuIcon: 'Biểu tượng thực đơn',//菜单图标
    clickToSelectIcon: 'Nhập vào biểu tượng chọn',//点击选择图标
    sort: 'Sắp xếp',//排序
    pleaseEnterSort: 'Hãy nhập số seri', // 请输入序号
    pleaseEnterMenuSort: 'Nhập sắp xếp thực đơn',//请输入菜单排序
    IfRouteMenu: 'Có phải danh mục định tuyến hay không?',//是否路由菜单
    hideRouting: 'Định tuyến ẩn',//隐藏路由
    ifCacheRoutes: 'Có phải định tuyến bộ nhớ hay không?',//是否缓存路由
    aggregateRouting: '',//聚合路由
    openMethod: 'Phương thức mở',//打开方式
    external: 'Bên ngoài.',//外部
    internal: 'Nội bộ',//内部
    menuName: 'Tên thực đơn',//菜单名称
    basicInformation: 'Thông tin cơ bản',//基本信息
    userInformation: 'Thông tin người dùng', // 用户信息
    departUser: 'Bộ phận', // 部门角色
    organizationName: 'Tên tổ chức',//机构名称
    pleaseEnterOrganizationName: '请输入机构/部门名称',//请输入机构/部门名称
    upperDivision: 'Bộ phận cấp cao',//上级部门
    none: 'Không có',//无
    organizationCode: 'Mã cơ quan, đơn vị',//机构编码
    pleaseEnterTheOrganizationCode: 'Nhập mã tổ chức',//请输入机构编码
    orgShortCode: 'Mã rút gọn tổ chức',//机构简码
    PleaseEnterShortCode: 'Nhập mã ký hiệu của đơn vị/ tổ chức',//请输入机构简码
    organizationID: 'ID tổ chức',//机构标识码
    pleaseEnterOrgID: 'Nhập mã IDcủa tổ chức',//请输入机构标识码
    personIncharge: 'Người phụ trách',//负责人
    pleaseSelectPersonIncharge: 'Chọn người phụ trách',//请选择负责人
    divisionHead: 'Lãnh đạo phụ trách',//分管领导
    pleaseSelectDivisionHead: 'Chọn người quản lý',//请选择分管领导
    departAdmin: 'Department Administrator', // 部门管理员
    pleaseSelectDepartAdmin: 'Please select the department administrator', // 请选择部门管理员
    orgType: 'Loại hình tổ chức',//机构类型
    pleaseSelectOrgType: 'Chọn loại hình tổ chức',//请选择机构类型
    serviceGroup: 'Nhóm dịch vụ',//服务组
    enabledOrNot: 'Có khởi động hay không?',//是否启用
    enable: 'Cho phép sử dụng',//启用
    disable: 'Ngăn chặn/ cấm',//禁用
    pleaseSelectAdopterCode: 'Chọn mã số trang trại',//请选择养户编码
    farms: 'Trại chăn nuôi',//养殖场
    cellPhoneNumber: 'Số di động',//手机号
    pleaseInputCellPhoneNumber: 'Nhập số điện thoại',//请输入手机号
    factoryType: '工厂类型',//工厂类型
    pleaseSelectFactoryType: 'Chọn kiểu nhà máy',//请选择工厂类型
    uniformCreditCode: '统一信用代码',//统一信用代码
    feedMillCode: 'Mã nhà máy',//饲料厂编码
    pleaseEnterFeedMillCode: 'Xin mời nhập số hiệu nhà máy cám',//请输入饲料厂编码
    costCenter: 'Giá thành trung tâm',//成本中心
    pleaseEnterCostCenter: 'Nhập giá chính',//请输入成本中心
    farmType: 'Loại hình nông trại',//农场类型
    pleaseSelectFarmType: 'Chọn loại trang trại',//请选择农场类型
    standardEmptyBarnPeriod: 'Tiêu chuẩn trống',//标准空舍期
    farmManager: 'Chiều dài',//场长
    pleaseEnterFarmManager: 'Nhập chiều dài trại',//请输入场长
    farmProperties: 'Thuộc tính nông trại',//农场属性
    pleaseSelectFarmProperty: 'Chọn thuộc tính trang trại',//请选择农场属性
    customer: 'Khách hàng sở hữu',//所属客户
    pleaseEnterTheCustomerYouBelongTo: 'Xin mời nhập khách hàng sở hữu',//请输入所属客户
    buildingStatus: 'Tình trạng chuồng',//栋舍状态
    pleaseSelectStatusOfBuilding: 'Xin mời chọn trạng thái ô chuống',//请选择栋舍状态
    addressOnly: 'Địa chỉ',//地址
    pleaseSelectAddress: 'Chọn địa chỉ',//请选择地址
    capacity: 'Năng lực sản xuất',//产能
    startUpTime: 'Thời gian sử dụng',//启用时间
    pleaseSelectStartUpTime: 'Chọn thời gian bắt đầu sử dụng',//请选择启用时间
    deactivationTime: 'Thời gian ngừng sử dụng',//停用时间
    pleaseSelectDeactivationTime: 'Chọn thời gian vô hiệu hóa',//请选择停用时间
    buildingLength: 'Chiều dài chuồng',//栋舍长度
    buildingWidth: 'Chiều rộng chuồng',//栋舍宽度
    breedingArea: 'Diện tích chăn nuôi',//养殖面积
    breedingMethod: 'Hình thức chăn nuôi',//养殖方式
    pleaseSelectBreedingMethod: 'Chọn loại hình chăn nuôi',//请选择养殖方式
    verticalFanPower: 'Công suất quạt dọc',//竖向风机功率
    horizontalFanPower: 'Công suất ngang',//横向风机功率
    detailedAddress: 'Địa chỉ chi tiết',//详细地址
    pleaseEnterDetailAddress: 'Nhập địa chỉ',//请输入地址
    departmentPermissions: 'Cơ quan ban ngành',//部门权限
    pleaseEnterDaysInStandardVacancyPeriod: 'Mời nhập số ngày trống chuồng tiêu chuẩn',//请输入标准空舍期天数
    oldPassword: 'Mật khẩu cũ',//旧密码
    pleaseEnterOldPassword: 'Nhập mật khẩu cũ',//请输入旧密码
    newPassword: 'Mật khẩu mới',//新密码
    pleaseEnterNewPassword: 'Xin mời nhập mật khẩu mới',//请输入新密码
    confirmNewPassword: 'Xác nhận mật khẩu mới',//确认新密码
    pleaseConfirmNewPassword: 'Xin mời nhập mật khẩu mới',//请输入新密码
    hatchery: 'Trạm ấp',//孵化场
    pleaseSelectHatchery: 'Chọn trạm ấp',//请选择孵化场
    inspectedWarehouse: 'Kiểm tra nhà kho',//待检仓库
    pleaseSelectInspectedWarehouse: 'Chọn nhà kho chưa kiểm tra',//请选择待检仓库
    seedEggBatchNumber: 'Số lô trứng giống',//种蛋批号
    pleaseSelectSeedEggBatchNumber: 'Chọn số lô trứng giống',//请选择种蛋批号
    byProductWarehouse: 'Kho sản phẩm phụ',//副产品仓库
    eggWarehouse: 'Kho trứng giống',//种蛋仓库
    incubationFarm: '孵化农场',//孵化农场
    pleaseSelectIncubationFarm: 'Chọn nông trại ấp trứng',//请选择孵化农场
    operationType: 'Kiểu hoạt động',//操作类型
    pleaseSelectOperationType: 'Chọn loại hoạt động',//请选择操作类型
    incubator: 'Số máy ấp',//孵化器
    pleaseSelectIncubator: 'Chọn máy ấp trứng',//请选择孵化器
    incubationBatchNumber: 'Số lô ấp',//孵化批号
    pleaseSelectIncubationBatchNumber: 'Chọn số lô ấp trứng',//请选择孵化批号
    hatcher: 'Máy ấp',//出雏器
    pleaseSelectHatcher: 'Chọn máy ấp nở',//请选择出雏器
    immunizationDate: 'Ngày miễn dịch',//免疫日期
    pleaseSelectImmunizationDate: 'Xin mời chọn ngày miễn dịch',//请选择免疫日期
    roleName: 'Tên vài trò',//角色名称
    pleaseEnterRoleName: 'Xin mời nhập tên vai trò',//请输入角色名称
    languageName: 'Tên Ngôn ngữ', // 语言名称
    languageCode: 'Mã Ngôn ngữ', // 语言编码
    pleaseEnterlanguageName: 'Hãy nhập tên ngôn ngữ', // 请输入语言名称
    pleaseEnterlanguageCode: 'Hãy nhập mã ngôn ngữ', // 请输入语言编码
    languageDescription: 'đa ngôn ngữ', // 多语言描述
    pleaseEnterLanguageDescription: 'Hãy nhập vào một mô tả đa dạng', // 请输入多语言描述
    associatedDatabaseTable: 'Bàn dữ liệu liên kết', // 关联数据库表
    pleaseEnterAssociatedDatabaseTable: 'Hãy nhập vào bảng dữ liệu tương ứng.', // 请输入关联数据库表
    associatedDataField: 'Phạm vi dữ liệu liên quan', // 关联数据字段
    pleaseEnterAssociatedDataField: 'Hãy nhập vào trường dữ liệu tương ứng.', // 请输入关联数据字段
    associatedBusinessType: 'Kiểu làm ăn liên quan', // 关联业务类型
    associatedEntityField: 'Đồng diện thực thể', // 关联实体字段
    roleCode: 'Vai trò mã hóa',//角色编码
    pleaseEnterRoleCode: 'Xin mời nhập mã số vai trò',//请输入角色编码
    twoToThirtyCharactersInLength: 'Độ dài từ 2-30 ký tự',//长度在 2 到 30 个字符
    upToSixtyFourCharactersInLength: 'Độ dài không quá 64 ký tự',//长度不超过 64 个字符
    LessThanCharacters_126: 'Độ dài không quá 126 ký tự',//长度不超过 126 个字符
    noChineseCharactersAllowed: 'Mã ký tự không được nhập tiếng Trung Quốc',//角色编码不可输入汉字
    userAccount: 'Tài khoản người dùng',//用户账号
    departUserName: 'Tên bộ phận', // 部门角色名称
    pleaseEnterDepartUserName: 'Hãy nhập tên bộ phận', // 请输入部门角色名称
    departUserCode: 'Mã bộ phận', // 部门角色编码
    pleaseEnterDepartUserCode: 'Hãy nhập mật mã bộ phận', // 请输入部门角色编码
    pleaseEnterAccount: 'Xin mời nhập tên tài khoản',//请输入用户账号
    loginPassword: 'Nhập mật khẩu',//登录密码
    pleaseEnterLoginPassword: 'Nhập mật khẩu',//请输入登录密码
    confirmPassword: 'xác nhận mật khẩu',//确认密码
    pleaseConfirmLoginPassword: 'Xin mời nhập lại mật khẩu đăng nhập',//请重新输入登录密码
    userName: 'Tên người dùng',//用户姓名
    pleaseEnterUsername: 'Nhập tên người dùng',//请输入用户姓名
    realName: 'Real Name', // 真实名字
    pleaseEnterRealName: 'Please enter the real Name', // 真实名字
    pleaseEnterCellPhoneNumber: 'Please enter cell phone number',//请输入手机号
    userStatus: 'User Status', //用户状态
    employeeID: 'Mã số nhân viên',//工号
    pleaseEnterWorkNumber: 'Nhập mã số nhân viên',//请输入工号
    position: 'Chức vụ',//职务
    pleaseSelectJobTitle: 'Vui lòng chọn lựa chức vụ',//请选择职务
    roleAssignment: 'Phân bổ vai trò nhiệm vụ',//角色分配
    pleaseSelectUserRole: 'Vui lòng điền vai trò người dùng',//请选择用户角色
    departmentAssignment: 'Phân bổ bộ phận',//部门分配
    clickToSelectDepartment: 'Bấm để chọn bộ phận',//点击选择部门
    tenantAssignment: 'Phân phối hộ thuê',//租户分配
    selectTenantAssignment: 'Xin mời chọn phân phối đối tượng thuê',//请选择租户分配
    identity: 'Thân phận',//身份
    normalUser: 'Người dùng chung',//普通用户
    supervisor: 'Cấp cao',//上级
    mainDepartment: 'main Department', // 归属部门
    pleaseSelectMainDepartment: 'Please select the main department', // 请选择归属部门
    responsibleDepartment: 'Bộ phận chịu trách nhiệm',//负责部门
    pleaseSelectDepartmentInCharge: 'Chọn bộ phận phụ trách',//请选择负责部门
    image: 'Ảnh đại diện',//头像
    upload: 'Tải lên.',//上传
    birthday: 'Ngày sinh',//生日
    pleaseSelectYourBirthday: 'Vui lòng điền ngày sinh',//请选择生日
    workflowEngine: 'Công cụ quy trình làm việc',//工作流引擎
    pleaseSelectWhetherSynchronizeWorkflowEngine: 'Vui lòng chọn có đồng bộ hóa quy trình làm việc hay không',//请选择是否同步工作流引擎
    male: 'Nam',//男
    female: 'Nữ',//女
    pleaseEnterCorrectTelNumber: '请输入正确的座机号码',//请输入正确的座机号码
    deliveryOrderNo: 'Số phiếu ấp',//出雏单号
    pleaseSelectDeliveryOrderNo: 'Chọn số phiếu ấp nở',//请选择出雏单号
    hatchingDate: 'Thời gian ấp',//出雏日期
    pleaseSelectHatchingDate: 'Chọn ngày nở trứng',//请选择出雏日期
    eggBatch: 'Lô trứng giống',//种蛋批次
    pleaseSelectEggBatch: 'Chọn lô trứng giống',//请选择种蛋批次
    numberOfEggKnocks: 'Kiểm tra số lượng trứng vỡ',//敲蛋检查数
    pleaseEnterTheNumberOfEggKnocks: 'Mời nhập số lượng trứng đã kiểm tra',//请输入敲蛋检查数
    resetPassword: 'Cài đặt lại mật khẩu',//重新设定密码
    thePasswordEnteredTwiceIsNotTheSame: '2 lần nhập khẩu không giống nhau',//两次输入的密码不一样
    dictionaryName: 'Tên từ điển',//字典名称
    pleaseEnterDictionaryName: 'Nhập tên trong từ điển',//请输入字典名称
    dictionaryNumber: 'Mã số từ điển',//字典编号
    pleaseEnterDictionaryNum: 'Nhập số thứ tự trong từ điển',//请输入字典编号
    dictionaryFetch: 'Truy xuất từ điển',//字典取回
    normal: 'Thông thường',//正常
    pleaseEnterDataValue: 'Nhập giá trị dữ liệu',//请输入数据值
    dataValue: 'Giá trị số liệu',//数据值
    sortByVal: 'Sắp xếp theo giá trị',//排序值
    smallerFront: '值越小越靠前，支持小数',//值越小越靠前，支持小数
    dataValuesCannotContainSpecialChar: 'Giá trị dữ liệu không được bao gồm các kí tự đặc biệt!',//数据值不能包含特殊字符！
    dictionaryList: 'Danh sách từ điển',//字典列表
    deleteDictionaryCompletely: 'Xóa sạch từ điển',//彻底删除字典
    areYouSureDeleteDictionaryCompletely: 'Bạn có chắc muốn xóa từ điển này không?',//您确定要彻底删除这个字典项吗?
    notePleaseBeCarefulItCannotBeRecoveredAfterDeletion: '注意：彻底删除后将无法恢复，请谨慎操作！',//注意：彻底删除后将无法恢复，请谨慎操作！
    categoryName: 'Tên danh mục',//分类名称
    categoryCode: 'Mã phân loại',//分类编码
    parentNode: '父级节点越南语',//父级节点
    pleaseSelectParentNode: '',//请选择父级节点
    pleaseInputCategoryName: 'Nhập tên danh mục',//请输入分类名称
    user: 'Người sử dụng',//用户
    permissionsHeld: 'Quyền hạn vốn có',//所拥有的权限
    pleaseSelectHigherDepartmentision: 'Chọn ngành cấp cao',//请选择上级部门
    fax: 'fax',//传真
    pleaseEnterFax: 'Nhập bản sao',//请输入传真
    menu: 'Thực đơn',//菜单
    ruleName: 'Tên quy cách',//规则名称
    pleaseEnterRuleName: 'Nhập tên điều luật',//请输入规则名称
    ruleValue: 'Giá trị quy cách',//规则值
    pleaseEnterRuleVal: 'Nhập giá trị điều luật',//请输入规则值
    ruleField: 'Nội quy trường',//规则字段
    pleaseEnterRuleField: 'Vui lòng nhập quy tắc',//请输入规则字段
    conditionalRule: 'Điều kiện quy tắc',//条件规则
    pleaseEnterConditionalRule: 'Xin mời nhập điều kiện quy tắc',//请输入条件规则
    valid: 'Có hiệu lực',//有效
    invalid: 'Không hợp lệ',//无效
    pleaseEnterDepartmentName: ' 请输入部门名称',// 请输入部门名称
    department: ' 部门',// 部门
    pleaseSelectServiceDepartment: ' 请选择部门',// 请选择部门
    eRPSingleNumber: 'ERP单号',//ERP单号
    pleaseEnterERPSingleNumber: ' 请输入ERP单号',// 请输入ERP单号
    storehouseType: '仓库类型',//仓库类型
    pleaseSelectStorehouseType: '请选择仓库类型',//请选择仓库类型
    pleaseSelectFarms: ' 请选择养殖场',// 请选择养殖场
    pleaseEnterFarmingBatch: ' 请输入养殖批次',// 请输入养殖批次
    applicant: 'Người xin',//申请人
    pleaseSelectApplicant: '请选择申请人',//请选择申请人
    pleaseEnterTheDocumentNumber: '请输入单据编号',//请输入单据编号
    breedingCycle: 'Chu kỳ chăn nuôi',//养殖周期
    pleaseEnterTheBreedingPeriod: '请输入养殖周期',//请输入养殖周期
    plannedNumberOfSeedlings: '计划进苗数量',//计划进苗数量
    giftAmount: '赠与数量',//赠与数量
    pleaseEnterTheGiftAmount: '请输入赠与数量',//请输入赠与数量
    theNumberOfShipments: '发货数量',//发货数量
    pleaseEnterTheShippingQuantity: '请输入发货数量',//请输入发货数量
    plannedDateOfSeedling: '计划进苗日期',//计划进苗日期
    pleaseSelectThePlannedDateOfSeedling: '请选择计划进苗日期',//请选择计划进苗日期
    serviceCompany: '服务公司',//服务公司
    pleaseSelectAServiceCompany: '请选择服务公司',//请选择服务公司
    affiliatedCompany: '所属公司',//所属公司
    pleaseSelectaffiliatedCompany: '请选择所属公司',//请选择所属公司
    affiliatedTechnicalStaffNumber: '所属技术员工号',//所属技术员工号
    pleaseSelectaffiliatedTechnicalStaffNumber: '请选择所属技术员工号',//请选择所属技术员工号
    whetherSelfEmployed: 'Có phải hộ cá thể',//是否个体户
    pleaseSelectWhetherSelfEmployed: '请选择是否个体户',//请选择是否个体户
    whetherEnterprise: '是否企业',//是否企业
    pleaseSelectWhetherEnterprise: '是否企业',//是否企业
    growerStatus: 'Trạng thái hộ chăn nuôi',//养户状态
    pleaseSelectGrowerStatus: 'Xin mời chọn trạng thái hộ chăn nuôi',//请选择养户状态
    statusChangeTime: 'Thời gian thay đổi trạng thái',//状态改变时间
    pleaseSelectTheTimeOfStatusChange: 'Xin mời chọn thời gian trạng thái thay đổi',//请选择状态改变时间
    distanceToCompany: '距公司公里数',//距公司公里数
    pleaseEnterTheNumberOfKilometersFromTheCompany: 'Hãy nhập số km tới công ty',//请输入距离公司公里数
    country: 'Quốc gia',//国家
    province: 'Tỉnh',//省份
    city: '市/地级市',//市/地级市
    county: '县/区',//县/区
    street: '乡镇/街道/社区',//乡镇/街道/社区
    pleaseEnterTheStreet: '请输入乡镇/街道/社区',//请输入乡镇/街道/社区
    address: 'Địa chỉ ( Đường, số nhà )',//地址(街道门牌号)
    pleaseEnterTheAddress: 'Nhập địa chỉ ( Đường, số nhà)',//请输入地址(街道门牌号)
    telephone: 'Điện thoại',//电话
    pleaseEnterYourPhoneNumber: 'Nhập số điện thoại',//请输入电话
    spouseName: 'Tên vợ/chồng',//配偶姓名
    pleaseEnterYourSpouseName: 'Nhập tên vợ/ chồng',//请输入配偶姓名
    spouseCellPhone: 'Điện thoại vợ/chồng',//配偶手机
    pleaseEnterYourSpouseCellPhone: 'Nhập số điện thoại vợ/ chồng',//请输入配偶手机
    spouseIDNumber: 'Số ID trống/ mái',//配偶身份证号
    pleaseEnterYourSpouseIDNumber: 'Nhập số CMTND vợ/ chồng',//请输入配偶身份证号
    homeAddress: 'Địa chỉ nhà',//家庭地址
    pleaseEnterYourHomeAddress: 'Nhập địa chỉ nhà',//请输入家庭地址
    bankAccount: 'Tên của Ngân hàng',//开户银行
    pleaseInputTheBankAccount: 'Nhập tên ngân hàng mở tài khoản',//请输入开户银行
    bankAddress: 'Địa chỉ ngân hàng',//开户行地址
    pleaseEnterTheBankAddress: 'Nhập địa chỉ ngân hàng',//请输入开户行地址
    bankCardNumber: '银行卡号',//银行卡号
    pleaseInputTheBankCardNumber: '请输入银行卡号',//请输入银行卡号
    validOrNot: 'Có hiệu quả không',//是否有效
    pleaseChooseWhetherItIsValidOrNot: 'Xin mời chọn có hiệu quả không',//请选择是否有效
    remarks: 'Ghi chú',//备注
    pleaseEnterANote: 'Mời nhập ghi chú',//请输入备注
    pleaseEnterTheCorrectIDCardNumber: '请输入正确的身份证号',//请输入正确的身份证号
    pleaseEnterTheCorrectIDNumberOfYourSpouse: '请输入正确的配偶身份证号',//请输入正确的配偶身份证号
    pleaseEnterTheCorrectCellPhoneNumber: '请输入正确的手机号码',//请输入正确的手机号码
    sureToSubmit: '确定提交吗',//确定提交吗
    oKToWriteOff: '确定冲销吗',//确定冲销吗
    applicationOrderNo: '申请单号',//申请单号
    pleaseSelectTheApplicationNo: '请选择申请单号',//请选择申请单号
    shippingWarehouse: '发货仓库',//发货仓库
    contractID: '合同号',//合同号
    pleaseInputTheContractID: '请输入合同号',//请输入合同号
    detailPrimaryKey: '明细主键',//明细主键
    pleaseSelectLotNo: '请选择批号',//请选择批号
    mustBeOrPositiveInteger: '发货数量必须是或者正整数',//发货数量必须是或者正整数
    settlementAmount: 'Số tiền quyết toán',//结算金额
    partyA: '甲方公司',//甲方公司
    pleaseSelectPartyA: '请选择甲方公司',//请选择甲方公司
    partyB: '乙方养户',//乙方养户
    pleaseSelectPartyB: '请选择乙方养户',//请选择乙方养户
    contracName: '合同名称',//合同名称
    pleaseEnterTheContractName: '请输入合同名称',//请输入合同名称
    cooperationMode: '合作模式',//合作模式
    pleaseSelectTheCooperationMode: '请选择合作模式',//请选择合作模式
    contractType: '合同类型',//合同类型
    pleaseSelectTheContractType: '请选择合同类型',//请选择合同类型
    dateOfSigning: 'ngày kí hợp đồng',//签订日期
    pleaseSelectTheDateOfSigning: '请选择签订日期',//请选择签订日期
    terminationDate: '终止日期',//终止日期
    pleaseSelectTheTerminationDate: '请选择合同终止日期',//请选择合同终止日期
    signingPlace: 'Địa điểm kí kết',//签订地点
    pleaseEnterThePlaceOfSigning: '请输入签订地点',//请输入签订地点
    industry: '行业',//行业
    pleaseInputTheIndustry: '请输入行业',//请输入行业
    contractText: '合同文本',//合同文本
    pleaseEnterTheContractText: '请输入合同文本',//请输入合同文本
    whetherStandardText: '是否标准文本',//是否标准文本
    pleaseSelectWhetherTheStandardContractText: '请选择是否标准合同文本',//请选择是否标准合同文本
    currency: '币种',//币种
    pleaseEnterTheCurrency: '请输入币种',//请输入币种
    localCurrency: '本位币',//本位币
    pleaseEnterTheLocalCurrency: '请输入本位币',//请输入本位币
    conversionRate: '折本汇率',//折本汇率
    pleaseEnterTheConversionRate: '请输入折本汇率',//请输入折本汇率
    breedingCategory: '养殖品类',//养殖品类
    pleaseSelectSpecies: 'Chọn chủng loại',//请选择品类
    breedingStrain: '养殖品系',//养殖品系
    pleaseSelectAStrain: 'Chọn hệ giống',//请选择品系
    generation: 'Thế hệ',//代次
    gender: '养殖性别',//养殖性别
    pleaseSelectSpecies: '请选择物种',//请选择物种
    breederAdministrator: '养户管理员',//养户管理员
    pleaseEnterTheBreederAdministrator: '请输入养户管理员',//请输入养户管理员
    serviceGroup: 'Nhóm dịch vụ',//服务组
    pleaseSelectTheServiceGroup: '请选择服务组',//请选择服务组
    enteringPerson: '录入人',//录入人
    serviceTeamLeader: '服务组长',//服务组长
    pleaseEnterTheServiceGroupLeader: '请输入服务组长',//请输入服务组长
    marketingTeamLeader: '营销组长',//营销组长
    pleaseEnterTheMarketingTeamLeader: '请输入营销组长',//请输入营销组长
    salesperson: '营销员',//营销员
    pleaseEnterTheMarketingStaff: '请输入营销员',//请输入营销员
    changeOfContractCode: '变更合同编码',//变更合同编码
    pleaseEnterTheChangeContractCode: '请输入变更合同编码',//请输入变更合同编码
    changeTime: '变更时间',//变更时间
    pleaseSelectTheTimeOfChange: '请选择变更时间',//请选择变更时间
    reasonForChange: '变更原因',//变更原因
    pleaseEnterTheReasonForChange: '请输入变更原因',//请输入变更原因
    modifyTheContractText: '修改合同文本',//修改合同文本
    pleaseEnterTheTextOfTheModifiedContract: '请输入修改合同文本',//请输入修改合同文本
    breedingStandard: 'Tiêu chuẩn chăn nuôi',//养殖标准
    pleaseEnteANumber: '请输入数字',//请输入数字
    age: 'số ngày chăn nuôi',//饲养天数
    pleaseEnterAge: '请输入饲养天数',//请输入饲养天数
    numberOfContracts: '合同数量',//合同数量
    pleaseEnterTheNumberOfContracts: '请输入合同数量',//请输入合同数量
    day: '天',//天
    only: '只',//只
    maximumLivability: '成活率上限',//成活率上限
    pleaseEnterTheUpperLimitOfLivability: '请输入标准成活率上限',//请输入标准成活率上限
    minimumLivability: '成活率下限',//成活率下限
    pleaseEnteTheMinimumLivability: '请输入标准成活率下限',//请输入标准成活率下限
    wtandardLivability: '标准成活率',//标准成活率
    pleaseEnterTheStandardLivability: '请输入标准成活率',//请输入标准成活率
    weightLimit: '体重上限',//体重上限
    pleaseEnterTheUpperLimitOfStandardWeight: '请输入标准体重上限',//请输入标准体重上限
    lowerWeightLimit: '体重下限',//体重下限
    pleaseEnterTheLowerStandardWeightLimit: '请输入标准体重下限',//请输入标准体重下限
    standardWeight: '标准体重',//标准体重
    pleaseEnterStandardWeight: '请输入标准体重',//请输入标准体重
    uniformityUpperLimit: '均匀度上限',//均匀度上限
    pleaseEnterTheUpperLimitOfStandardEvenness: '请输入标准均匀度上限',//请输入标准均匀度上限
    lowerLimitOfUniformity: '均匀度下限',//均匀度下限
    pleaseEnterTheLowerLimitOfStandardUniformity: '请输入标准均匀度下限',//请输入标准均匀度下限
    standardUniformity: '标准均匀度',//标准均匀度
    pleaseEnterTheStandardUniformity: '请输入标准均匀度',//请输入标准均匀度
    upperLimitOfConsumption: '耗用量上限',//耗用量上限
    pleasEnterTheUpperLimitOfConsumptionPerUnit: '请输入单只耗用量上限',//请输入单只耗用量上限
    lowerLimitOfConsumption: '耗用量下限',//耗用量下限
    pleaseEnterTheLowerLimitOfConsumptionPerUnit: '请输入单只耗用量下限',//请输入单只耗用量下限
    standardConsumption: '标准耗用量',//标准耗用量
    pleaseEnterTheConsumptionAmountPerUnit: '请输入单只耗用量',//请输入单只耗用量
    upperLimitOfMeatRatio: 'FCR max',//料肉比上限
    pleaseEnterTheUpperLimitOfStandardMeatRatio: '请输入标准料肉比上限',//请输入标准料肉比上限
    lowerLimitOfMeatRatio: 'FCR min',//料肉比下限
    pleaseEnterTheLowerLimitOfStandardMeatRatio: '请输入标准料肉比下限',//请输入标准料肉比下限
    standardMeatRatio: '标准料肉比',//标准料肉比
    pleaseEnterTheStandardMeatRatio: '请输入标准料肉比',//请输入标准料肉比
    pleaseEnterAWholeNumber: '请输入整数',//请输入整数
    pleaseEnterANumber: '请输入数字',//请输入数字
    feather: '羽',//羽
    feedCost: 'Giá thành cám',//饲料成本
    pleaseEnterTheFeedCostStandard: '请输入饲料成本标准',//请输入饲料成本标准
    rMBBird: '元/只',//元/只
    medicineCost: 'Giá thành thuốc',//药品成本
    pleaseInputTheCostStandardOfMedicine: '请输入药品成本标准',//请输入药品成本标准
    maleBirdAGrade: '公禽A级',//公禽A级
    pleaseEnterTheUnitPriceForTheRecoveryOfMaleBirdAGrade: '请输入公禽A级回收单价',//请输入公禽A级回收单价
    femaleAGrade: '母禽A级',//母禽A级
    pleaseEnterTheUnitPriceForTheRecoveryOfFemaleBirdAGrade: '请输入母禽A级回收单价',//请输入母禽A级回收单价
    maleB: '公禽B级',//公禽B级
    pleaseEnterTheUnitPriceOfMaleBirdBGrade: '请输入公禽B级回收单价',//请输入公禽B级回收单价
    femaleBirdBGrade: '母禽B级',//母禽B级
    pleaseEnterTheUnitPriceOfBGradeOfFemaleBirds: '请输入母禽B级回收单价',//请输入母禽B级回收单价
    maleBirdResidual: '公禽残次',//公禽残次
    pleaseEnterTheUnitPriceOfMaleBirdResidualRecovery: '请输入公禽残次回收单价',//请输入公禽残次回收单价
    femaleBirdResidual: '母禽残次',//母禽残次
    pleaseEnterTheUnitPriceOfFemalePoultryResidualRecovery: '请输入母禽残次回收单价',//请输入母禽残次回收单价
    yuanKg: '元/Kg',//元/Kg
    settlementBasis: 'cơ sở quyết toán',//结算依据
    pleaseSelectTheBasisOfSettlement: '请选择结算依据',//请选择结算依据
    standardDailyFeePerAnimal: '每只每日标准代养费',//每只每日标准代养费
    pleaseEnterTheStandardDailyFeePerAnimal: '请输入每只每日标准代养费',//请输入每只每日标准代养费
    dividendPrice: '分红价格',//分红价格
    pleaseEnterTheDividendPrice: '请输入分红价格',//请输入分红价格
    companyCapitalPreservationPoint: '公司保本点',//公司保本点
    pleaseEnterTheCompanyCapitalPreservationPoint: '请输入公司保本点',//请输入公司保本点
    capitalPreservationPointForFarmers: '养户保本点',//养户保本点
    pleaseInputTheCapitalPreservationPointOfTheAdopter: '请输入养户保本点',//请输入养户保本点
    profitRatioOfPartyA: '甲方盈利比例',//甲方盈利比例
    pleaseEnterTheProfitRatioOfPartyA: '请输入盈利比例甲方',//请输入盈利比例甲方
    profitRatioOfPartyB: '乙方盈利比例',//乙方盈利比例
    pleaseInputTheProfitRatioOfPartyB: '请输入盈利比例乙方',//请输入盈利比例乙方
    LossRatioOfPartyA: '甲方亏损比例',//甲方亏损比例
    pleaseEnterThePercentageOfLossForPartyA: '请输入亏损比例甲方',//请输入亏损比例甲方
    partyBLossRatio: '乙方亏损比例',//乙方亏损比例
    pleaseInputLossRatioPartyB: '请输入亏损比例乙方',//请输入亏损比例乙方
    settlementAmountForPartyA: '甲方结算金额',//甲方结算金额
    settlementAmountOfPartyB: '乙方结算金额',//乙方结算金额
    yuan: '元',//元
    pleaseEnterTheCorrectAmount: '请输入正确的金额',//请输入正确的金额
    pleaseEnterTheUnitPrice: '请输入单价',//请输入单价
    balance: '余额',//余额
    pleaseEnterTheBalance: '请输入余额',//请输入余额
    amount: '金额',//金额
    pleaseEnterTheAmount: '请输入金额',//请输入金额
    unitPrice: '单价',//单价
    maximumLength6Bits: '最大长度6位',//最大长度6位
    planNo: '计划编号',//计划编号
    pleaseEnterPlanNo: '请输入计划编号',//请输入计划编号
    planDescription: ' 计划描述',// 计划描述
    pleaseEnterPlanDescription: '请输入计划描述',//请输入计划描述
    batchNo: '养殖批次',//养殖批次
    pleaseSelectBatchNo: '请选择养殖批次',//请选择养殖批次
    noPicture: '无图片',//无图片
    noFile: '无文件',//无文件
    download: '下载',//下载
    totalPlacement: '进苗总量',//进苗总量
    plannedPlacementDate: '计划进苗日期',//计划进苗日期
    confirmationTime: '确认时间',//确认时间
    reviewStatus: '审核状态',//审核状态
    maximumLength6Bits: '最大长度6位',//最大长度6位
    confirmSynchronization: '确定同步',//确定同步
    pleaseSelectAData: '请选择一条数据',//请选择一条数据
    thePlacementDateMustBeGreaterThanOrEqualToTheStartDate: '入舍日期必须大于等于批次空舍开始日期',//入舍日期必须大于等于批次空舍开始日期
    mustBeGreaterThanOrEqualTo0: '必须大于等于0',//必须大于等于0
    ifYouDoNotHaveAnAuditorYouCannotSubmit: '没有设置审核人员,不能提交',//没有设置审核人员,不能提交
    reviewer: 'Người phê duyệt',//审核人
    deliveryFarm: '交货农场',//交货农场
    sourceOrderType: '源单类型',//源单类型
    pleaseSelectTheSourceOrderType: '请选择源单类型',//请选择源单类型
    auxiliaryQuantity: '辅助数量',//辅助数量
    confirmCopy: '确定复制',//确定复制
    confrimToGenerateAStatement: '确定生成结算单',//确定生成结算单
    pleaseSelectTheBreedingStandard: '请选择养殖标准',//请选择养殖标准
    pleaseEnterTheDocumentNo: '请输入单据编号',//请输入单据编号
    pleaseSelectTheFarmNo: '请选择养殖场编号',//请选择养殖场编号
    pleaseSelectTheFarmerNo: '请选择养户编号',//请选择养户编号
    pleaseSelectTheStrain: 'Chọn hệ giống',//请选择品系
    speciesClassification: '物种分类',//物种分类
    strain: 'Quá tải',//品系
    pleaseSelectSpecies: 'Chọn chủng loại',//请选择品类
    pleaseInputTheBreedingCycle: '请输入养殖周期',//请输入养殖周期
    plannedNoOfPlacement: '计划进苗数量',//计划进苗数量
    pleaseInputThePlannedNoOfPlacement: '请输入计划进苗数量',//请输入计划进苗数量
    noOfGrants: '赠与数量',//赠与数量
    pleaseEnterTheNoOfGifts: '请输入赠与数量',//请输入赠与数量
    noOfShipments: '发货数量',//发货数量
    pleaseEnterTheNoOfShipments: '请输入发货数量',//请输入发货数量
    plannedDateOfPlacement: '计划进苗日期',//计划进苗日期
    pleaseSelectThePlannedDateOfPlacement: '请选择计划进苗日期',//请选择计划进苗日期
    pleaseInputTheApplicant: '请输入申请人',//请输入申请人
    productLine: '产品线',//产品线
    pleaseSelectTheProductLine: '请选择产品线',//请选择产品线
    auditStatus: '审核状态',//审核状态
    pleaseSelectTheAuditStatus: '请选择审核状态',//请选择审核状态
    validOrNot: 'Có hiệu quả không',//是否有效
    pleaseChooseWhetherItIsValidOrNot: 'Xin mời chọn có hiệu quả không',//请选择是否有效
    confirmedBy: '确认人',//确认人
    pleaseEnterThePersonWhoConfirmed: '请输入确认人',//请输入确认人
    pleaseEnterTheBatchNo: '请输入养殖批次编号',//请输入养殖批次编号
    pleaseEnterFarmNo: '请输入养殖场编号',//请输入养殖场编号
    pleaseEnterTheGrowerNo: '请输入养户编号',//请输入养户编号
    pleaseEnterTheContractId: '请输入合同编号',//请输入合同编号
    pleaseEnterTheNoOfGrants: '请输入赠送数量',//请输入赠送数量
    pleaseSelectTheCompanyCode: '请选择公司编码',//请选择公司编码
    pleaseSelectFarmCode: '请选择农场编码',//请选择农场编码
    pleaseSelectWarehouseCode: '请选择仓库编码',//请选择仓库编码
    applicationTime: '申请时间',//申请时间
    pleaseSelectTheApplicationTime: '请选择申请时间',//请选择申请时间
    pleaseEnterTheDocumentCategory: '请输入单据类别',//请输入单据类别
    billingPeriod: '单据账期',//单据账期
    pleaseSelectTheBillablePeriod: 'Chọn thời hạn thanh toán',//请选择单据账期
    demandTime: '需求时间',//需求时间
    pleaseSelectTheDemandTime: '请选择需求时间',//请选择需求时间
    requestedArrivalTime: '要求到货时间',//要求到货时间
    pleaseSelectTheRequiredArrivalTime: '请选择要求到货时间',//请选择要求到货时间
    qtyRequested: '申请数量',//申请数量
    pleaseEnterTheQtyRequested: '请输入申请数量',//请输入申请数量
    pleaseSelectTheQtyToBeShipped: '请选择发货数量',//请选择发货数量
    receivedQty: '收货数量',//收货数量
    pleaseEnterTheNoOfGoodsReceived: '请输入收货数量',//请输入收货数量
    pleaseEnterTheUnit: '请输入单位',//请输入单位
    unitNo: '单位编号',//单位编号
    pleaseEnterTheUnitNo: '请输入单位编号',//请输入单位编号
    costUnitPrice: '成本单价',//成本单价
    pleaseEnterTheCostUnitPrice: '请输入成本单价',//请输入成本单价
    pleaseEnterTheSettlementUnitPrice: '请输入结算单价',//请输入结算单价
    documentNo: 'Số chứng từ',//单据编号
    chickenApplicationForm: '鸡苗申请单',//鸡苗申请单
    pleaseSelectChickenApplicationForm: '请选择鸡苗申请单',//请选择鸡苗申请单
    species: 'Chủng loại',//品种
    plannedDateOfPlacement: '进苗计划日期',//进苗计划日期
    pleaseEnterThePlannedDateOfPlacement: '请输入进苗计划日期',//请输入进苗计划日期
    shippingWarehouse: '发货仓库',//发货仓库
    pleaseSelectTheWarehouseForChickenDelivery: '请选择鸡发货仓库',//请选择鸡发货仓库
    pleaseEnterTheSettlementAmount: '请输入结算金额',//请输入结算金额
    pleaseEnterTheType: '请输入类型',//请输入类型
    documentDetails: 'Chi tiết tài liệu',//单据明细
    breedingLot: '养殖批次',//养殖批次
    entryType: 'Loại hình nhập kho',//入库类型
    materialDetails: 'Chi tiết vật liệu',//物料明细
    death: ' 死亡数量',// 死亡数量
    pleaseEnterTheNoOfDeaths: '请输入死亡数量',//请输入死亡数量
    noOfCulling: '淘汰数量',//淘汰数量
    pleaseEnterTheNoOfCulling: '请输入淘汰数量',//请输入淘汰数量
    temperature: '温度',//温度
    pleaseEnterTheTemperature: '请输入温度',//请输入温度
    humidity: '湿度',//湿度
    pleaseInputHumidity: '请输入湿度',//请输入湿度
    batchNumber: '批次编号',//批次编号
    pleaseEnterTheBatchNumber: '请输入批次编号',//请输入批次编号
    batchName: 'Tên lô',//批次名称
    pleaseEnterTheBatchName: 'Nhập tên lứa nuôi',//请输入批次名称
    pleaseSelectTheContractNumber: '请选择合同编号',//请选择合同编号
    feedingCycle: '饲养周期',//饲养周期
    pleaseEnterTheFeedingCycle: '请输入饲养周期',//请输入饲养周期
    species: 'Chủng loại sản phẩm',//品类
    pleaseSelectStrain: 'Chọn chủng loại',//请选择品类
    strain: 'Quá tải',//品系
    pleaseSelectAStrain: 'Chọn hệ giống',//请选择品系
    generation: 'Thế hệ',//代次
    initialAge: '初始日龄',//初始日龄
    pleaseEnterTheInitialAge: '请输入初始日龄',//请输入初始日龄
    plannedNumberOfChicks: '计划入雏数量',//计划入雏数量
    pleaseEnterThePlannedNumberOfChicks: '请输入计划入雏数量',//请输入计划入雏数量
    actualNumberOfChicks: '实际入雏数量',//实际入雏数量
    pleaseEnterTheActualNumberOfChicks: '请输入实际入雏数量',//请输入实际入雏数量
    remarks: 'Ghi chú',//备注
    pleaseEnterAComment: 'Mời nhập ghi chú',//请输入备注
    contractNo: 'số hợp đồng',//合同编号
    costItemClassificationCode: '费用项分类编码',//费用项分类编码
    pleaseEnterTheCostItemClassificationCode: '请输入费用项分类编码',//请输入费用项分类编码
    costItemClassification: '费用项分类',//费用项分类
    pleaseEnterTheCostItemClassification: '请输入费用项分类',//请输入费用项分类
    status: 'Trạng thái',//状态
    pleaseSelectAStatus: 'Vui lòng điền trạng thái',//请选择状态
    pleaseEnterTheSupplierCode: '请输入供应商编码',//请输入供应商编码
    dateOfDemand: 'Ngày yêu cầu',//需求日期
    materialNumber: '物料编号',//物料编号
    pleaseSelectTheMaterialNo: '请选择物料编号',//请选择物料编号
    pleaseEnterTheMaterialNo: '请输入物料编号',//请输入物料编号
    materialCommonName: '物料通用名',//物料通用名
    pleaseEnterTheCommonNameOfTheMaterial: '请输入物料通用名',//请输入物料通用名
    synchronousUpdate: '同步更新',//同步更新
    model: '型号',//型号
    unitOfMeasurement: '计量单位',//计量单位
    description: '说明描述',//说明描述
    materialCommonNameFileNo: '物料通用名档案编号',//物料通用名档案编号
    pleaseSelectTheMaterialCommonNameFileNo: '请选择物料通用名档案编号',//请选择物料通用名档案编号
    pleaseEnterTheMaterialCommonName: '请输入物料通用名',//请输入物料通用名
    contractCode: 'số đơn hợp đồng',//合同编码
    pleaseSelectTheContractCode: '请选择合同编码',//请选择合同编码
    batchCode: '批次编码',//批次编码
    pleaseSelectBatchCode: '请选择批次编码',//请选择批次编码
    contracts: '合同',//合同
    batch: '批次',//批次
    pleaseSelectFarm: '请选择养殖场',//请选择养殖场
    receipt: '领用',//领用
    confirmApproval: '确定审核通过',//确定审核通过
    securityDepositOperation: '保证金操作',//保证金操作
    bookkeepingDate: '记账日期',//记账日期
    applicationInitiationTime: '申请发起时间',//申请发起时间
    lastApprover: '最后审批人',//最后审批人
    lastApprovalTime: '最后审批时间',//最后审批时间
    pleaseSelectContract: '请选择合同',//请选择合同
    pleaseSelectBatch: '请选择批次',//请选择批次
    batchSize: '批次规模',//批次规模
    businessDate: '业务日期',//业务日期
    businessType: '业务类型',//业务类型
    operationTime: '操作时间',//操作时间
    placementQty: '入雏数量',//入雏数量
    currentStock: '当前存栏数',//当前存栏数
    reasonForApplication: '申请原因',//申请原因
    auditStatus: '审核状态',//审核状态
    dateOfApplication: '申请日期',//申请日期
    finalApprover: '最后审批人',//最后审批人
    pleaseSelectContractNo: '请选择放养合同号',//请选择放养合同号
    applicationType: '申请类型',//申请类型
    totalAmount: '金额合计',//金额合计
    accountDate: '记账日期',//记账日期
    applicationInitiationDate: '申请发起日期',//申请发起日期
    cooperationModel: '合作模式',//合作模式
    partyBDividendRatio: '乙方分红比例',//乙方分红比例
    marketPrice: '市场价格',//市场价格
    exceedingPrice: '超出价格',//超出价格
    stocker: '放养员',//放养员
    stockerInCharge: '放养负责人',//放养负责人
    totalWeight: '出栏总重量',//出栏总重量
    dividendAmount: '分红金额',//分红金额
    okToUpdateTheStatement: '确定更新结算单',//确定更新结算单
    okToWithdraw: '确定撤回吗',//确定撤回吗
    withdraw: '撤回',//撤回
    partyA: '甲方公司',//甲方公司
    partyB: '乙方养户',//乙方养户
    contractName: '合同名称',//合同名称
    cooperationMode: '合作模式',//合作模式
    contractType: '合同类型',//合同类型
    dateOfContractSigning: '合同签订日期',//合同签订日期
    contractEffectiveDate: '合同生效日期',//合同生效日期
    contractTerminationDate: '合同终止日期',//合同终止日期
    placeOfSigning: 'Địa điểm kí kết',//签订地点
    sector: 'Bộ phận',//部门
    enteredBy: '录入人',//录入人
    conversionRate: '折本汇率',//折本汇率
    fosterCareAdministrator: '养户管理员',//养户管理员
    serviceGroup: 'Nhóm dịch vụ',//服务组
    contractVersion: '合同版本',//合同版本
    batchNo: '批次编号',//批次编号
    pleaseEnterTheBatchNo: '请输入批次编号',//请输入批次编号
    batchOperation: 'Thao tác hàng loạt',//批量操作
    sureToWriteOff: '确定冲销吗',//确定冲销吗
    sureToDelete: '确定删除吗',//确定删除吗
    material: 'Vật tư',//物料
    pleaseSelectMaterial: '请选择物料',//请选择物料
    effectiveTime: '生效时间',//生效时间
    expirationTime: '失效时间',//失效时间
    isTheMaterialValid: '物料是否有效',//物料是否有效
    pleaseSelectACompany: 'Chọn công ty',//请选择公司
    pleaseSelectAContract: '请选择合同',//请选择合同
    formula: '公式',//公式
    pleaseEnterAFormula: '请输入公式',//请输入公式
    substituteMaintenanceFeeCalculationFormula: '代养费计算公式',//代养费计算公式
    confirmDeletionOfThisItem: '确认删除此项',//确认删除此项
    verify: '验证',//验证
    variables: '变量',//变量
    operators: '运算符',//运算符
    pleaseEnterANo: '请输入数字',//请输入数字
    marketPriceRevenue: '市场价收入',//市场价收入
    contractPriceRevenue: '合同价收入',//合同价收入
    specificFeedCost: '特定饲料成本',//特定饲料成本
    chickCost: 'giá thành gà giống',//鸡苗成本
    feedCost: 'Giá thành cám',//饲料成本
    drugCost: 'Giá thành thuốc',//药品成本
    vaccineCost: '疫苗成本',//疫苗成本
    totalCost: '总费用',//总费用
    totalReward: '总奖励',//总奖励
    totalPenalty: '总处罚',//总处罚
    catchQty: '出栏只数',//出栏只数
    catchWeight: 'Trọng lượng xuất chuồng',//出栏重量
    contractAverageWeight: '合同均重',//合同均重
    unitSurrogateBreedingFee: '单位代养费',//单位代养费
    unitManagementCost: '单位管理费用',//单位管理费用
    salesCostPerUnit: '单位销售费用',//单位销售费用
    enterANo: '输入数字',//输入数字
    pleaseEnterCompany: '请输入公司',//请输入公司

    chickenPrice: '成鸡价格',// 成鸡价格
    materialCategory: '物料类别',//物料类别
    mainUnitOfMeasurement: '主计量单位',//主计量单位
    pleaseEnterTheMainUnitOfMeasurement: '请输入主计量单位',//请输入主计量单位
    pleaseInputTheApplicationAmount: '请输入申请金额',//请输入申请金额
    pleaseSelectTheDateOfRecording: '请选择记账日期',//请选择记账日期
    pleaseSelectTheDateOfApplicationInitiation: '请选择申请发起日期',//请选择申请发起日期
    dividendRatio: '分红比例',//分红比例
    pleaseEnterThePercentageOfDividends: '请输入分红比例',//请输入分红比例
    pleaseEnterTheDividendPrice: '请输入分红价格',//请输入分红价格
    pleaseEnterTheMarketPrice: '请输入市场价格',//请输入市场价格
    pleaseEnterTheExcessPrice: '请输入超出价格',//请输入超出价格
    pleaseSelectAStocker: '请选择放养员',//请选择放养员
    pleaseSelectThePersonInChargeOfStocking: '请选择放放养负责人',//请选择放放养负责人
    pleaseEnterTheTotalCatchWeight: '请输入出栏总重量',//请输入出栏总重量
    pleaseEnterTheAmountOfDividends: '请输入分红金额',//请输入分红金额
    fileCode: '档案编码',//档案编码
    pleaseEnterTheFileCode: '请输入档案编码',//请输入档案编码
    fileDescription: '档案描述',//档案描述
    pleaseEnterTheFileDescription: '请输入档案描述',//请输入档案描述
    affiliateCategory: '关联类别',//关联类别
    costItems: '成本项目',//成本项目
    diseaseFileCode: '疾病档案编码',//疾病档案编码
    pleaseEnterTheDiseaseFileCode: '请输入疾病档案编码',//请输入疾病档案编码
    diseaseCategory: '疾病类别',//疾病类别
    pleaseSelectADiseaseCategory: '请选择疾病类别',//请选择疾病类别
    diseaseFileDescription: '疾病档案描述',//疾病档案描述
    associatedDiseaseCategories: '关联疾病类别',//关联疾病类别
    diseaseDescription: '疾病说明',//疾病说明
    symptomProfileCodes: '症状档案编码',//症状档案编码
    pleaseEnterTheSymptomProfileCode: '请输入症状档案编码',//请输入症状档案编码
    symptomProfileName: '症状档案名称',//症状档案名称
    pleaseEnterTheNameOfTheSymptomProfile: '请输入症状档案名称',//请输入症状档案名称
    fileType: '档案类型',//档案类型
    symptomFileDescription: '症状档案描述',//症状档案描述
    treatmentPlanName: '治疗方案名称',//治疗方案名称
    pleaseEnterTheNameOfTheTreatmentPlan: '请输入治疗方案名称',//请输入治疗方案名称
    treatmentPlanDescription: '治疗方案描述',//治疗方案描述
    organsAnatomyFileCode: '脏器解剖档案编码',//脏器解剖档案编码
    pleaseEnterTheAnatomyFileCode: '请输入脏器解剖档案编码',//请输入脏器解剖档案编码
    anatomyFileName: '脏器解剖档案名称',//脏器解剖档案名称
    pleaseEnterTheNameOfTheOrganAutopsyFile: '请输入脏器解剖档案名称',//请输入脏器解剖档案名称
    pleaseSelectValidOrNot: '请选择是否有效',//请选择是否有效
    visceralAnatomyFileType: '脏器解剖档案类型',//脏器解剖档案类型
    organDissectionClassification: '脏器解剖分类',//脏器解剖分类
    descriptionOfTheOrganDissectionFile: '脏器解剖档案描述',//脏器解剖档案描述
    inspectionSubcategoryCode: '巡检小类编码',//巡检小类编码
    pleaseEnterTheInspectionSubcategoryCode: '请输入巡检小类编码',//请输入巡检小类编码
    descriptionOfInspectionSubcategory: '巡检小类描述',//巡检小类描述
    pleaseEnterTheInspectionSubcategoryDescription: '请输入巡检小类描述',//请输入巡检小类描述
    inspectionCategory: '巡检大类',//巡检大类
    pleaseSelectTheInspectionCategory: '请选择巡检大类',//请选择巡检大类
    inspectionSubCategoryNumber: '巡检小类编号',//巡检小类编号
    nameOfInspectionCategory: '巡检小类名称',//巡检小类名称
    recurringIndicatorFileNumber: '循环指标档案编号',//循环指标档案编号
    pleaseEnterTheCycleIndexFileNumber: '请输入循环指标档案编号',//请输入循环指标档案编号
    circularIndicatorFileName: '循环指标档案名称',//循环指标档案名称
    pleaseEnterTheNameOfTheCircularIndicatorFile: '请输入循环指标档案名称',//请输入循环指标档案名称
    breedingCategory: '饲养品类',//饲养品类
    feedingStage: '饲养阶段',//饲养阶段
    survivalRate: '成活率',//成活率
    averageWeightOfAdultChickens: '成禽均重',//成鸡均重
    feedingAmount: '喂料量',//喂料量
    realMeatRatio: '真实料肉比',//真实料肉比
    regularRatio: '常规料肉比',//常规料肉比
    serviceCompanyGuaranteePoint: '服务公司保本点',//服务公司保本点
    seedlingPriceToMeatRatio: '种苗价肉比',//种苗价肉比
    feedToMeatRatio: '饲料价肉比',//饲料价肉比
    vaccinePriceToMeatRatio: '疫苗价肉比',//疫苗价肉比
    healthCareMedicinePriceToMeatRatio: '保健药价肉比',//保健药价肉比
    treatmentMedicinePriceToMeatRatio: '治疗药价肉比',//治疗药价肉比
    priceToMeatRatioForPayingFarmers: '支付养户成本价肉比',//支付养户成本价肉比
    fileName: '档案名称',//档案名称
    pleaseEnterTheNameOfTheFile: '请输入档案名称',//请输入档案名称
    standardCycleIndicatorNumber: '标准循环指标编号',//标准循环指标编号
    standardCycleIndicatorName: '标准循环指标名称',//标准循环指标名称
    pleaseEnterTheFileName: '请输入档案名称',//请输入档案名称
    chickenInspectionCode: '鸡苗检查编码',//鸡苗检查编码
    descriptionOfChickenInspection: '鸡苗检查描述',//鸡苗检查描述
    pleaseSelectTheCategoryOfAssociation: '请选择关联类别',//请选择关联类别
    pleaseSelectTheTypeOfFile: '请选择档案类型',//请选择档案类型
    symptomCategory: '症状类别',//症状类别
    pleaseSelectAnExpenseItemCategory: '请选择费用项类别',//请选择费用项类别
    pleaseEnterADiseaseFileDescription: '请输入疾病档案描述',//请输入疾病档案描述
    associatedDiseaseDescription: '关联疾病说明',//关联疾病说明
    pleaseEnterADiseaseDescription: '请输入疾病说明或描述',//请输入疾病说明\描述
    symptomProfile: '症状档案',//症状档案
    symptomName: '症状名称',//症状名称
    symptomDescription: '症状说明',//症状说明
    visceralAnatomyProfile: '脏器解剖档案',//脏器解剖档案
    organAnatomyName: '脏器解剖名称',//脏器解剖名称
    organAnatomyDescription: '脏器解剖说明',//脏器解剖说明
    treatmentPlanFile: '治疗方案档案',//治疗方案档案
    treatmentProtocolName: '治疗方案名称',//治疗方案名称
    treatmentProtocolDescription: '治疗方案说明',//治疗方案说明
    symptomCategory: '症状类别',//症状类别
    pleaseEnterTheSymptomFileCode: '请输入症状档案编码',//请输入症状档案编码
    pleaseEnterTheNameOfTheSymptomProfile: '请输入症状档案名称',//请输入症状档案名称
    symptomProfileDescription: '症状档案描述',//症状档案描述
    pleaseEnterTheSymptomProfileDescription: '请输入症状档案描述',//请输入症状档案描述
    treatmentPlanCode: '治疗方案编码',//治疗方案编码
    pleaseEnterTheTreatmentPlanCode: '请输入治疗方案编码',//请输入治疗方案编码
    treatmentPlanDescription: '治疗方案描述',//治疗方案描述
    pleaseEnterTheTreatmentProtocolDescription: '请输入治疗方案描述',//请输入治疗方案描述
    organsAnatomyCategory: '脏器解剖类别',//脏器解剖类别
    pleaseSelectAnatomyCategory: '请选择脏器解剖类别',//请选择脏器解剖类别
    descriptionOfTheOrganAutopsyFile: '脏器解剖档案描述',//脏器解剖档案描述
    pleaseEnterTheOrganAutopsyFileDescription: '请输入脏器解剖档案描述',//请输入脏器解剖档案描述
    pleaseEnterTheInspectionItemDescription: '请输入巡检项描述',//请输入巡检项描述
    pleaseSelectTheBreedingCategory: '请选择饲养品类',//请选择饲养品类
    pleaseEnterTheFeedingStage: '请输入饲养阶段',//请输入饲养阶段
    pleaseSelectRearingPeriod: '请选择饲养周期',//请选择饲养周期
    pleaseInputTheSurvivalRate: '请输入成活率',//请输入成活率
    pleaseEnterTheAverageWeightOfAdultChickens: '请输入成禽均重',//请输入成鸡均重
    pleaseEnterTheFeedingRate: '请输入喂料量',//请输入喂料量
    pleaseEnterTheRealMeatRatio: '请输入真实料肉比',//请输入真实料肉比
    pleaseEnterTheRegularMeatRatio: '请输入常规料肉比',//请输入常规料肉比
    pleaseEnterTheServiceCompanyGuaranteePoint: '请输入服务公司保本点',//请输入服务公司保本点
    pleaseEnterTheSeedlingPriceToMeatRatio: '请输入种苗价肉比',//请输入种苗价肉比
    pleaseEnterFeedPriceToMeatRatio: '请输入饲料价肉比',//请输入饲料价肉比
    pleaseEnterVaccinePriceToMeatRatio: '请输入疫苗价肉比',//请输入疫苗价肉比
    pleaseEnterHealthDrugPriceToMeatRatio: '请输入保健药价肉比',//请输入保健药价肉比
    pleaseEnterThePriceOfTherapeuticDrugs: '请输入治疗药价肉比',//请输入治疗药价肉比
    pleaseEnterTheMeatRatioOfTheCostOfPayingFarmers: '请输入支付养户成本价肉比',//请输入支付养户成本价肉比
    pleaseSelectMenuType: '请选择菜单类型', // 请选择菜单类型
    whetherInventoryManagement: '是否库存管理',//是否库存管理
    deliveryDate: '交货日期',//交货日期
    pleaseSelectDeliveryDate: '请选择交货日期', // 请选择交货日期
    batchSource: '批次来源',//批次来源
    pleaseSelectBatchSource: '请选择批次来源',//请选择批次来源
    pleaseSelectEffectiveTime: '请选择生效时间',//请选择生效时间
    pleaseSelectContractID: '请选择合同号',//请选择合同号
    settlementUnitPrice: '结算单价',//结算单价
    pleaseSelectTheBreedingStandard: '请选择养殖标准',//请选择养殖标准
    docCost: '禽苗成本',//禽苗成本
    pleaseEnterTheDocCost: '请输入禽苗成本标准',//请输入禽苗成本标准
    unitPriceType: '单价类型',//单价类型
    marginRecord: '保证金记录',//保证金记录
    businessItem: '业务项目',//业务项目
    placementDate: '进鸡日期',//进鸡日期
    changeType: '变更类型',//变更类型
    pleaseSelectChangeType: '请选择变更类型',//请选择变更类型
    method: '方式',//方式
    pleaseSelectMethod: '请选择方式',//请选择方式
    drawDownContractPriceList: '提取合同价格清单',//提取合同价格清单
    docApplicationForm: '禽苗申请单',//禽苗申请单
    pleaseSelectTheDocRequestForm: '请选择禽苗申请单',//请选择禽苗申请单
    pleaseSelectThePoultryDeliveryWarehouse: '请选择禽发货仓库',//请选择禽发货仓库
    pleaseEnter0OrPositiveInteger: '请输入0或正整数',//请输入0或正整数
    pleaseSelectBusinessType: '请选择业务类型',//请选择业务类型
    paymentMethod: '付款方式',//付款方式
    theCodeMustStartWithALetterAndCanContainNumbersUnderscoresHorizontalBars: '编码必须以字母开头，可包含数字、下划线、横杠',//编码必须以字母开头，可包含数字、下划线、横杠'
    extractTheListOfContractPrices: '提取合同价格清单',//提取合同价格清单
    pleaseSelectThePaymentMethod: '请选择付款方式',//请选择付款方式
    pleaseSelectTheApplicationInitiationTime: '请选择申请发起时间',//请选择申请发起时间
    mustBe0OrAPositiveInteger: '必须为0或正整数',//必须为0或正整数
    minimumPrice: '最低价',//最低价
    lowestPriceCannotBeGreaterThanTheHighestPrice: '最低价不能大于最高价',//最低价不能大于最高价
    highestPrice: '最高价',//最高价
    theHighestPriceCannotBeLessThanTheLowestPrice: '最高价不能小于最低价',//最高价不能小于最低价
    eggStorage: '蛋品入库(换羽)',//蛋品入库(换羽)
    detailImport: '明细导入',//明细导入
    materialConversionDetails: '物料转换明细',//物料转换明细
    newFarm: '新增养殖场',//新增养殖场
    kiloBird: '斤/羽',//斤/羽
    rmbKilo: '元/斤',//元/斤
    changeRange: '变更范围',//变更范围
    settlementDate: '结算日期',//结算日期
    breedingContract: '养殖合同',//养殖合同
    pleaseEnterTheBreedingContract: '请输入养殖合同',//请输入养殖合同
    pleaseSelectTheSettlementDate: '请选择结算日期',//请选择结算日期
    numberOfSlaughter: '出栏数量',//出栏数量
    bird: '羽',//羽
    deductedWeight: '扣减重量',//扣减重量
    deductionAmount: '扣减金额',//扣减金额
    pleaseEnterTheAmountToBeDeducted: '请输入扣减金额',//请输入扣减金额
    increaseInWeight: '增加重量',//增加重量
    pleaseEnterTheIncreaseWeight: '请输入增加重量',//请输入增加重量
    increaseAmount: '增加金额',//增加金额
    pleaseEnterTheIncreaseAmount: '请输入增加金额',//请输入增加金额
    averageUnitPrice: '平均单价',//平均单价
    pleaseEnterTheAverageUnitPrice: '请输入平均单价',//请输入平均单价
    pleaseEnterTheNumberOfSlaughters: '请输入出栏数量',//请输入出栏数量
    theNumberOfSlaughterMustBeGreaterThan0: '出栏数量必须大于0',//出栏数量必须大于0
    pleaseEnterTheContractQuantity: '请输入合同数量',//请输入合同数量
    contractQuantityMustBeGreaterThan0: '合同数量必须大于0',//合同数量必须大于0
    pleaseEnterTheSlaughterWeight: '请输入出栏重量',//请输入出栏重量
    slaughterWeightMustBeGreaterThan0: '出栏重量必须大于0',//出栏重量必须大于0
    pleaseEnterTheDeductionWeight: '请输入扣减重量',//请输入扣减重量
    deductedWeightMustBeGreaterThanOrEqualTo0: '扣减重量必须大于等于0',//扣减重量必须大于等于0
    pleaseEnterTheIncreaseWeight: '请输入增加重量',//请输入增加重量
    increaseWeightMustBeGreaterThanOrEqualTo0: '增加重量必须大于等于0',//增加重量必须大于等于0
    unitPriceMustBeGreaterThanOrEqualTo0: '单价必须大于等于0',//单价必须大于等于0
    amountMustBeGreaterThanOrEqualTo0: '金额必须大于等于0',//金额必须大于等于0
    pleaseEnterTheAmountToBeDeducted: '请输入扣减金额',//请输入扣减金额
    deductionAmountMustBeGreaterThanOrEqualTo0: '扣减金额必须大于等于0',//扣减金额必须大于等于0
    pleaseEnterTheIncreaseAmount: '请输入增加金额',//请输入增加金额
    theIncreaseAmountMustBeGreaterThanOrEqualTo0: '增加金额必须大于等于0',//增加金额必须大于等于0
    numberOfSlaughtered: '出栏羽数',//出栏羽数
    weightOfSlaughter: '出栏重量(kg)',//出栏重量(kg)
    averagePigeonWeight: '平均羽重(kg/羽)',//平均羽重(kg/羽)
    amountOfRecovery: '回收金额',//回收金额
    numberOfDoc: '禽苗数',//禽苗数
    pleaseEnterTheNumberOfDoc: '请输入禽苗数',//请输入禽苗数
    mortality: '死淘数',//死淘数
    pleaseEnterTheMortaility: '请输入死淘数',//请输入死淘数
    numberOfGifts: '赠送数',//赠送数
    pleaseEnterTheNumberOfGifts: '请输入赠送数',//请输入赠送数
    amountOfDoc: '禽苗金额',//禽苗金额
    pleaseEnterTheAmountOfDoc: '请输入禽苗金额',//请输入禽苗金额
    feedConsumption: '饲料耗用量',//饲料耗用量
    pleaseEnterTheAmountOfFeedConsumed: '请输入饲料耗用量',//请输入饲料耗用量
    amountOfFeed: '饲料金额',//饲料金额
    pleaseEnterTheAmountOfFeed: '请输入饲料金额',//请输入饲料金额
    amountOfMedicineConsumption: '药品耗用金额',//药品耗用金额
    pleaseEnterTheAmountOfMedicineConsumption: '请输入药品耗用金额',//请输入药品耗用金额
    amountOfVaccineConsumption: '疫苗耗用金额',//疫苗耗用金额
    pleaseEnterTheAmountOfVaccineConsumption: '请输入疫苗耗用金额',//请输入疫苗耗用金额
    totalAmount: '合计金额',//合计金额
    pleaseEnterTheTotalAmount: '请输入合计金额',//请输入合计金额
    pleaseEnterTheMortality: '请输入死淘数',//请输入死淘数
    amountRecovered: '回收金额',//回收金额
    pleaseEnterTheAmountRecovered: '请输入回收金额',//请输入回收金额
    costAmount: '成本金额',//成本金额
    pleaseEnterTheCostAmount: '请输入成本金额',//请输入成本金额
    subsidyAmount: '补贴金额',//补贴金额
    pleaseEnterTheAmountOfSubsidy: '请输入补贴金额',//请输入补贴金额
    otherSubsidies: '其他补贴',//其他补贴
    pleaseEnterOtherSubsidies: '请输入其他补贴',//请输入其他补贴
    costAmount: '费用金额',//费用金额
    pleaseEnterTheAmountOfExpenses: '请输入费用金额',//请输入费用金额
    penaltyAmount: '惩罚金额',//惩罚金额
    pleaseEnterTheAmountOfPenalty: '请输入惩罚金额',//请输入惩罚金额
    otherPenalties: '其他惩罚',//其他惩罚
    pleaseEnterOtherPenalties: '请输入其他惩罚',//请输入其他惩罚
    basicSurrogateFee: '基本代养费',//基本代养费
    marginBalance: '保证金余额',//保证金余额
    amountDue: '应付金额',//应付金额
    marginWithholding: '保证金扣缴',//保证金扣缴
    actualAmountPaid: '实付金额',//实付金额
    pleaseEnterTheAmountOfDepositWithholding: '请输入保证金扣缴金额',//请输入保证金扣缴金额
    settlementFormVerificationDidNotPass: '结算表单校验未通过',//结算表单校验未通过
    pleaseSelectTheDate: '请选择日期',//请选择日期
    pleaseEnterTheDailyPrice: '请输入每日价格',//请输入每日价格
    pleaseEnterTheNumber: '请输入编号',//请输入编号
    pleaseSelectTheStandardCycleIndexNumber: '请选择标准循环指标编号',//请选择标准循环指标编号
    pleaseEnterTheOrganAnatomyCategory: '请输入脏器解剖类别',//请输入脏器解剖类别
    pleaseEnterTheSymptomClassification: '请输入症状分类',//请输入症状分类
    farmName: '农场名称',//农场名称
    pleaseEnterTheNameOfTheFarm: '请输入农场名称',//请输入农场名称
    institutionType: '机构类型',//机构类型
    pleaseSelectTheTypeOfOrganization: '请选择机构类型',//请选择机构类型
    createABuilding: '创建栋舍',//创建栋舍
    pleaseChooseToCreateABuilding: '请选择创建栋舍',//请选择创建栋舍
    numberOfBuildings: '栋舍数',//栋舍数
    pleaseEnterTheNumberOfBuildings: '请输入栋舍数',//请输入栋舍数
    createWarehouse: '创建仓库',//创建仓库
    pleaseChooseToCreateAWarehouse: '请选择创建仓库',//请选择创建仓库
    permissionAssignment: '权限分配',//权限分配
    pleaseSelectUser: '请选择用户',//请选择用户
    pleaseSelectTheDrugWarehouse: '请选择药品仓库',//请选择药品仓库
    pleaseEnterTheWarehousingOrderNumber: '请输入入库单号',//请输入入库单号
    transferOutDepartment: '转出部门',//转出部门
    pleaseSelectTheTransferDepartment: '请选择转出部门',//请选择转出部门
    transferToDepartment: '转入部门',//转入部门
    pleaseSelectTheTransferDepartment: '请选择转入部门',//请选择转入部门
    date: '日期',//日期
    featherKg: '羽/KG',//羽/KG
    poultrySeedlings: '禽苗',//禽苗
    pleaseEnterPoultrySeedlings: '请输入禽苗',//请输入禽苗
    pleaseEnterAUsername: 'Please enter a username', // 请输入用户名!
    pleaseEnterAPassword: 'Please enter a password', // 请输入密码!
    pleaseEnterTheVerificationCode: 'Please enter the verification code', // 请输入验证码!
    pleaseDragTheSlider: 'Please drag the slider', // 请拖动滑块！
    loginFailed: 'Login Failed', // 登录失败
    pleaseUseChrome: 'Please use Google or Google kernel browser, otherwise the relevant functions will not work normally!', // 请使用谷歌或者谷歌内核浏览器，否则相关功能将不能正常使用！
    costItemCode: 'Cost Item Code', // 成本项编号
    costItemName: 'Cost Item Name', // 成本项名称
    pleaseEnterCostItemCode: 'Please enter cost item code!', // 请输入成本项编号
    pleaseEntercostItemName: 'Please enter cost item name!', // 请输入成本项名称
    generateVoucher: 'Generate Voucher',//生成凭证
    syncVoucher: 'Syn. Voucher',//同步凭证
    reverseVoucher: 'Reverse Voucher',//冲销凭证
    selectVoucher: 'selectVoucher',//凭证选择
    extractMaterialCost: 'Extract Material Cost',//生产成本提取
    extractOverhead: 'Extract Overhead',//制造费用提取
    extractStockVariance: 'Extract Stock Variance',//存栏变动提取
    allocateMaterialCost: 'Allocate Material Cost',//生产成本分摊
    allocateOverhead: 'Allocate Overhead',//制造费用分摊
    allocateCatchCost: 'Allocate Catch Cost',//出栏成本分摊
    tongbuyewuleixing: '同步业务类型',//同步业务类型
    taskName: 'Tên nhóm tác vụ', //任务类名
    cronExpression: 'cron biểu', //cron表达式
    args: 'tham số', //参数
    pleaseChooseTaskName: 'Hãy nhập tên hạng tác vụ', //任务类名
    pleaseEnterArgs: 'Hãy nhập tham số', //请输入参数
    taskStatus: 'Trạng thái tác vụ', //任务状态
    all: 'nguyên', //全部
    start: 'Khởi động',
    stop: 'Dừng', //停止
    started: 'Khởi đầu', //已启动
    paused: 'Dừng', //已暂停
    executeImmediately: 'Hành động ngay', //立即执行
    saveAndScheduleTasks: 'Việc lưu và lên lịch', //保存并安排任务
    applicableBusiness: 'Việc hoạt động', //适用业务
    pleaseChooseApplicableBusiness: 'Hãy chọn kinh doanh thích hợp' //请选择适用业务
  },
  tableHeader: {
    yonghumingcheng: 'usename',//用户名称
    kucunliang: 'Inventory', // 库存量
    businessPartners: 'Business partners', // 业务伙伴
    costItemCode: ' Cost Item Code', // 成本项编号
    costItemName: ' Cost Item Name', // 成本项名称
    documentNumber: 'Số chứng từ',//单据编号
    periodCode: '期间代码',//期间代码
    demandDate: 'Ngày yêu cầu',//需求日期
    serviceDepartmentOrFarm: '服务部或农场',//服务部或农场
    documentType: 'Loại chứng từ',//单据类型
    requestedArrivalDate: 'Thời gian kiến nghị nhận hàng',//要求到货日期
    createdBy: 'Người lập biểu',//创建人
    updateBy: 'Sửa', // 修改人
    updateTime: 'Thời gian sửa đổi', // 修改时间
    documentStatus: 'Trạng thái chứng từ',//单据状态
    syncStatus: 'Trạng thái đồng bộ',//同步状态
    syncMessage: '同步消息',//同步消息
    operation: 'Thao tác',//操作
    materialCode: 'Mã vật liệu',//物料编码
    materialName: 'Tên vật liệu',//物料名称
    manufacturer: 'Xưởng sản xuất',//厂家
    job: 'Comment',//职务
    titleName: 'Tựa', // 职务名称
    pleaseEnterTitleName: 'Hãy nhập tên công việc', // 请输入职务名称
    titleCode: 'Mã công việc', // 职务编码
    pleaseEnterTitleCode: 'Hãy nhập mã công việc', // 请输入职务编码
    titleRank: 'Cấp công việc', // 职务职级
    pleaseChooseTitleRank: 'Hãy chọn cấp công việc', // 请选择职务职级
    specification: 'Quy cách',//规格
    unit: 'Đơn vị',//单位
    quantity: 'Số lượng',//数量
    arrivalDate: 'Ngày giao hàng',//到货日期
    remarks: 'Ghi chú',//备注
    documentDate: 'Ngày chứng từ',//单据日期
    sourceInformation: 'Nguồn thông tin',//来源信息
    batchNumber: 'Số phê chuẩn',//批号
    supplierCode: 'Mã nhà cung ứng',//供应商编码
    supplierName: 'Tên nhà cung ứng',//供应商名称
    billingDate: 'Ngày chứng từ',//单据日期
    billingStatus: 'Loại chứng từ',//单据类型
    unitName: 'Tên công ty',//单位名称
    inboundQuantity: 'Số lượng nhập kho',//入库数量
    productionDate: 'Ngày sản xuất',//生产日期
    type: 'Loại hình/ kiểu',//类型
    purchaseContractNumber: 'Số hợp đồng thu mua',//采购合同号
    farm: 'Nông trại',//农场
    notClearQuantity: 'Số lượng còn tồn đọng',//未清数量
    requestedDateOfShipment: 'Ngày yêu cầu cấp hàng',//要求发货日期
    thirdPartySystemCode: 'Mã hệ thống thứ 3',//第三方系统编码
    number: 'Số seri',//编号
    weight: 'Trọng lượng',//重量
    postingDate: 'Ngày vào sổ',//过账日期
    customerCode: 'Mã khách hàng',//客户编码
    customerName: 'Tên khách hàng',//客户名称
    salesOrderNumber: 'Mã số đơn đặt hàng bán',//销售订单号
    operator: 'Người thực hiện',//操作人
    billLineNumber: '单据行号',//单据行号
    salesType: 'Loại hình bán hàng',//销售类型
    averageWeight: 'Trong lượng (g)',//均重(g)
    lineNumber: 'Số dòng',//行号
    numberOfOrders: 'Số đơn đặt hàng',//订单数
    outstanding: 'Số tồn đọng',//未清数
    warehouse: 'Kho',//仓库
    warehouseLocation: 'Vị trí kho',//库位
    expirationDate: 'Thời gian có hiệu lực',//有效期
    transferOutFarmServiceDepartment: '转出农场/服务部',//转出农场/服务部
    transferToFarmService: '转入农场/服务部',//转入农场/服务部
    materialCodeMaterialNameBatchWarehouseLocation: 'Mã số vật liệu/ Tên vật liệu/ Lô hàng/ Kho/ Vị trí kho',//物料编码|物料名称|批次|仓库|库位
    transferOutWarehouse: 'Kho chuyển đi',//转出仓
    transferOutWarehousePosition: 'Vị trí kho chuyển đi',//转出库位
    transferToWarehouse: 'Chuyển đến kho',//转入仓
    transferToWarehousePosition: 'Vị trí kho chuyển đến',//转入库位
    transferOutWarehouseCode: 'Mã số kho chuyển đi',//转出仓库编码
    transferOutWarehouseSpaceCode: 'Mã số vị trí kho chuyển đi',//转出库位编码
    building: 'Chuồng',//栋舍
    feedingLot: 'Số lứa chăn nuôi',//饲养批次
    averageEggWeight: 'Trọng lượng trứng trung bình', // 蛋均重（g）
    flockName: 'Tên lô',//批次名称
    placementAge: 'Ngày tuổi nhập chuồng',//入舍日龄
    generation: 'Thế hệ',//代次
    breed: 'Chủng loại',//品种
    status: 'Trạng thái',//状态
    breedingMethod: 'Hình thức chăn nuôi',//养殖方式
    creationTime: 'Thời gian lập biểu',//创建时间
    gender: 'Giới tính',//性别
    roundingNumber: '入舍数',//入舍数
    NumberOfStock: '存栏数',//存栏数
    conclusion: 'Kết luận',//结论
    dateOfAcceptance: 'Ngày nghiệm thu',//验收日期
    receivingAndInspectionPersonnel: 'Nhân viên nghiệm thu',//验收人员
    warehouseCode: 'Mã kho hàng',//仓库编码
    warehouseName: 'Tên kho',//仓库名称
    roadDamage: '路损',//路损
    quantityInStock: '库存数量',//库存数量
    feedingQuantity: 'Số lượng cho ăn',//饲喂数量
    feedingMethod: 'Phương pháp cho ăn',//饲喂方式
    feedingTime: 'Thời gian cho ăn ( phút )',//饲喂时间(分)
    quantityUsed: 'Liều lượng',//用量
    applicableScenario: 'Hoàn cảnh áp dụng',//适用场景
    genderBeforeConversion: 'Giới tính trước khi chuyển',//转换前性别
    materialAbbreviation: 'Gọi tắt vật liệu',//物料简称
    startingAge: 'Tuổi bắt đầu',//开始日龄
    theStartingAgeCannotBeGreaterThanTheEndingAge: 'Ngày tuổi bắt đầu không được lớn hơn ngày tuổi kết thúc',//起始日龄不能大于结束日龄
    endingAge: 'Tuổi kết thúc',//结束日龄
    endingAgeCannotBeLessThanStartingAge: 'Ngày tuổi kết thúc không thể nhỏ hơn ngày tuổi bắt đầu',//结束日龄不能小于起始日龄
    createdTime: 'Thời gian lập biểu',//创建时间
    modifiedBy: 'Người sửa đổi',//修改人
    modifiedAt: 'Thay đổi thời gian',//修改时间
    harvestMaterial: 'vật liệu xuất bán',//出栏物料
    fromMaterial: 'from物料',//from物料
    currentStock: 'Hàng tồn kho hiện tại',//当前存栏
    transferOutFarm: 'Trại chuyển đi',//转出农场
    transferOutOfTheBuilding: 'Chuồng chuyển đi',//转出栋舍
    transferToFarm: 'Trại chuyển đến',//转入农场
    stock: '存栏量',//存栏量
    dayAge: 'Ngày tuổi',//日龄
    numberOfTransfer: '转出数量',//转出数量
    numberOfTransfersIn: '转入数量',//转入数量
    transferOutBatch: 'Lô chuyển',//转出批次
    quantityReceived: 'Số lượng lĩnh dùng',//领用数量
    tibialLength: 'Chiều dài ( cm)',//胫长(cm)
    numberOfWeighs: '称重只数',//称重只数
    version: 'Bản in',//版本
    startDate: 'Ngày bắt đầu',//开始日期
    endDate: 'Ngày cuối',//结束日期
    dateOfCreation: '创建日期',//创建日期
    testResult: 'Kết quả xét nghiệm',//检测结果
    month: 'Tháng',//月份
    billMaker: 'Người lập phiếu',//制单人
    numberOfPeopleOnTheRegister: 'Số người đăng kí',//在册人数
    numberOfOutsideAssociates: 'Số lượng nhân viên thời vụ',//外协人数
    code: 'Mã số',//编码
    name: 'Tên',//名称
    shortName: 'Viết tắt',//简称
    farmerType: 'Loại hình hộ chăn nuôi',//养户类型
    whetherTheCompany: 'Có phải Công ty (Y: đúng, N: không)',//是否公司(Y是N否)
    breedingScale: 'Quy mô chăn nuôi',//养殖规模(只）
    breederStatus: 'Trạng thái hộ chăn nuôi',//养户状态
    telephone: 'Điện thoại',//电话
    contactPerson: 'Người liên hệ',//联系人
    affiliatedSupplierCode: 'Mã nhà cung cấp liên kết',//关联供应商编码
    numberOfDeaths: '死亡数量',//死亡数量
    culls: '淘汰数量',//淘汰数量
    sales: 'Số lượng tiêu thụ',//销售数量
    total: 'Tổng cộng',//合计
    partnerType: 'Loại đối tác',//伙伴类型
    partnerGrouping: 'Nhóm đối tác',//伙伴分组
    enterpriseType: 'Kiểu tầu:',//企业类型
    country: 'Quốc gia',//国家
    province: 'Tỉnh',//省份
    cityPrefectureLevelCity: '市/地级市',//市/地级市
    countyDistrict: '县/区',//县/区
    legalPerson: 'Người đại diện pháp luật',//法人
    materialGroupCode: 'Mã số nhóm vật liệu',//物料组编码
    materialGroup: 'Nhóm vật liệu',//物料组
    brand: 'Nhãn hiệu',//品牌
    spectrum: 'Phả hệ',//谱系
    stockUnit: 'Đơn vị tồn kho',//库存单位
    whetherValid: 'Có hiệu quả không',//是否有效
    description: 'Mô tả',//描述
    materialGroupClassification: 'Phân loại nhóm vật liệu',//物料组分类
    validity: 'Hiệu quả',//有效性
    ERPInventoryLocation: 'ERP库存地点',//ERP库存地点
    warehouseType: 'Loại lưu trữ',//仓储类型
    warehouseIdentification: 'Thẻ kho',//仓库标识
    maximumCapacity: 'Sức chứa tối đa ( kg)',//最大容量(kg)
    affiliatedWarehouse: 'Thuộc về kho',//所属仓库
    purchaseUnit: 'Đơn vị mua hàng',//采购单位
    salesUnit: 'Đơn vị bán hàng',//销售单位
    conversionRate: 'Tỷ lệ chuyển đổi',//换算率
    factoryCode: '工厂编码',//工厂编码
    batchManagement: 'Quản lý lô',//批次管理
    convertibleMaterialName: 'Tên vật tư chuyển đổi',//可转换物料名称
    incubationAgeFrom: 'Ấp từ ngày',//孵化日龄从
    hatchingAgeTo: 'Ấp đến ngày',//孵化日龄到
    standardType: 'Loại tiêu chuẩn',//标准类型
    category: 'Chủng loại sản phẩm',//品类
    enabledOrNot: 'Có khởi động hay không?',//是否启用
    enable: 'Cho phép sử dụng',//启用
    disable: 'Ngăn chặn/ cấm',//禁用
    lockedStatus: 'Trạng thái bị khóa',//锁定状态
    normal: 'Thông thường',//正常
    locked: 'Đã bị khóa',//已锁定
    defaultVersion: 'Phiên bản mặc định',//默认版本
    weekAge: 'Tuần tuổi',//周龄
    eggMaterialCode: 'Số mặt hàng trứng',//蛋品物料号
    eggMaterialName: 'Số tên nguyên liệu',//蛋品物料名称
    HenFeedNumber: 'Số hiệu cám gà mái',//母禽饲料号
    henFeedName: 'Tên cám gà mái',//母禽饲料名称
    standardGramOfHenFeed: 'Tiêu chuẩn tiêu hao cám gà mái (g)',//母禽饲料只耗标准g
    maleFeedNumber: '公禽饲料号',//公禽饲料号
    maleFeedName: 'Tên cám gà trống',//公鸡饲料名称
    standardGramOfMaleChickenFeed: '公鸡饲料只耗标准g',//公鸡饲料只耗标准g
    vaccinationPeriod: 'Chu kỳ miễn dịch',//免疫周期
    startMonth: 'Tháng bắt đầu',//开始月份
    theStartMonthCannotBeGreaterThanTheEndMonth: 'Tháng bắt đầu < Tháng kiết thúc',//开始月份不能大于结束月份
    endMonth: 'Tháng cuối',//结束月份
    theEndMonthCannotBeLessThanTheStartMonth: 'Tháng kết thúc không thể nhỏ hơn tháng bắt đầu',//结束月份不能小于开始月份
    target: 'Mục tiêu',//目标
    vaccineName: 'Tên vacxin',//疫苗名称
    vaccinationMethod: 'Phương pháp têm chủng',//接种方式
    dose: 'Liều lượng',//剂量
    item: 'Dự án',//项目
    individualMinimum: 'Giá trị cá thể nhỏ nhất',//个体最小值
    individualMinimumCannotBeGreaterThanIndividualMaximum: 'Giá trị cá thể nhỏ nhất không thể lớn hơn giá trị cá thể to nhất',//个体最小值不能大于个体最大值
    individualMaximum: 'Giá trị cá nhân tối đa',//个体最大值
    individualMaximumValueCannotBeLessThanIndividualMinimumValue: 'Giá trị cá thể lớn nhất không thể nhỏ hơn giá trị cá thể nhỏ nhất',//个体最大值不能小于个体最小值
    minimumAverage: 'Giá trị trung bình nhỏ nhất',//最小平均值
    theMinimumMeanCannotBeGreaterThanTheMaximumMean: 'Giá trị trung bình nhỏ nhất không được lớn hơn giá trị trung bình lớn nhất',//最小平均值不能大于最大平均值
    maximumMean: 'Giá trị trung bình cao nhất',//最大平均值
    theMaximumAverageCannotBeLessThanTheMinimumAverage: 'Giá trị trung bình cao nhất không được nhỏ hơn giá trị trung bình nhỏ nhất',//最大平均值不能小于最小平均值
    Dispersion: 'Độ rời rạc/ sự phân tán',//离散度
    lightDuration: 'Khoảng thời gian chiếu sáng',//光照时长
    minimumLightIntensity: 'Cường độ ánh sáng tối thiểu',//光照强度最小值
    maximumLightIntensity: 'Cường độ ánh sáng tối đa',//光照强度最大值
    temperatureMinimum: 'Nhiệt độ nhỏ nhất',//温度最小值
    temperatureMaximum: 'Nhiệt độ lớn nhất',//温度最大值
    highTemperatureAlarm: 'Báo động nhiệt độ cao',//高温报警
    lowTemperatureAlarm: 'Báo động nhiệt độ thấp',//低温报警
    humidityMinimum: 'Độ ẩm nhỏ nhất',//湿度最小值
    humidityMaximum: 'Độ ẩm lớn nhất',//湿度最大值
    carbonDioxide: 'Cac-bon đi-ô-xít',//二氧化碳
    feedingAmount: '饲喂量(克/只/天)',//饲喂量(克/只/天)
    livability: 'Tỷ lệ sống (%)',//成活率(%)
    bodyWeight: 'Cân nặng (gr)',//体重(克)
    weeklyEggProductionRate: 'Tỷ lệ đẻ theo tuần ( %)',//周产蛋率(%)
    htatchableEggRate: 'Tỷ lệ trứng giống đạt tiêu chuẩn (%)',//种蛋合格率(%)
    layingRateOfHousedHens: 'Tỷ lệ đẻ của gà mái tuần tuổi đẻ nhập chuồng (%)',//入舍母禽产蛋率(%)
    eggWeight: '蛋重(克)',//蛋重(克)
    hatchability: 'Tỷ lệ ấp trứng giống (%)',//种蛋孵化率(%)
    DOCLaidPerWeekByHousedHens: 'Số lượng gà mái tuần tuổi đẻ nhập chuồng',//入舍母禽周产雏数
    company: 'Công ty',//公司
    feedingAmount: '饲喂量/g',//饲喂量/g
    usage: 'Cách dùng',//用法
    grower: 'Hộ chăn nuôi',//养户
    feedNumber: 'Mã số thức ăn',//饲料编号
    feedName: 'Tên thức ăn',//饲料名称
    vaccineNumber: 'Số vacxin',//疫苗编号
    vaccineName: 'Tên vacxin',//疫苗名称
    drugNumber: 'Số hiệu thuốc',//药品编号
    drugName: 'Tên thuốc',//药品名称
    incubationDate: 'Ngày ấp trứng',//上孵日期
    poultrySpeciesBatch: '禽种批次',//禽种批次
    incubationsNumber: 'Số lượng ấp trước',//上孵数量
    incubator: 'Số máy ấp',//孵化器
    dropDate: 'Ngày đặt hàng',//落盘日期
    hatchingDate: 'Thời gian ấp',//出雏日期
    operationDate: 'Ngày thực hiện',//操作日期
    materialCodeBatchWarehouse: 'Mã số vật liệu/ Số lô hàng/ Kho',//物料编码|批次号|仓库
    hatchery: 'Trạm ấp',//孵化场
    targetWarehouse: 'Kho mục tiêu',//目标仓库
    secondaryUOMQuantity: 'Số lượng ( đơn vị phụ trợ tồn kho)',//辅计量数量
    inventoryNumber: 'Số lượng tồn',//库存数
    targetMaterialCode: 'Mã nguyên vật liệu',//目标物料编码
    targetMaterialname: 'Tên vật liệu',//目标物料名称
    incubationBatchNumber: 'Số lô ấp',//孵化批号
    incubationDays: 'Số ngày ấp',//孵化天数
    hatchingNumber: 'Số lượng đang ấp',//在孵数
    hatcher: 'Máy ấp',//出雏器
    eggByProductCodeBatchNumber: 'Mã sản phẩm phụ loại trứng/ Số lô',//蛋类副产品编码|批次号
    byProductDescription: 'Mô tả sản phẩm phụ',//副产品描述
    immuneMode: 'Phương pháp miễn dịch',//免疫方式
    dictionaryName: 'Tên từ điển',//字典名称
    dictionaryNumber: 'Mã số từ điển',//字典编号
    dataValue: 'Giá trị số liệu',//数据值
    categoryName: 'Tên danh mục',//分类名称
    categoryCode: 'Mã phân loại',//分类编码
    userAccount: 'Tài khoản người dùng',//用户账号
    userName: 'Tên người dùng',//用户姓名
    image: 'Ảnh đại diện',//头像
    birthday: 'Ngày sinh',//生日
    cellPhone: 'Số điện thoại',//手机号码
    department: 'Bộ phận',//部门
    roleCode: 'Vai trò mã hóa',//角色编码
    roleName: 'Tên vài trò',//角色名称
    menuName: 'Tên thực đơn',//菜单名称
    menuType: 'thực đơn',//菜单类型
    icon: '菜单图标t',//菜单图标
    frontComponents: 'Thành phần dao diện người dùng',//前端组件
    menuPath: 'Hưỡng dẫn thực đơn',//菜单路径
    sort: 'Sắp xếp',//排序
    ruleName: 'Tên quy cách',//规则名称
    ruleValue: 'Giá trị quy cách',//规则值
    ruleField: 'Nội quy trường',//规则字段
    eRPNumber: 'ERP单号',//ERP单号
    storehouseType: '仓库类型',//仓库类型
    farms: ' 养殖场',// 养殖场
    applicant: 'Người xin',//申请人
    contractNo: 'số hợp đồng',//合同编号
    numberOfApplications: '申请数量',//申请数量
    theNumberOfShipments: '发货数量',//发货数量
    receiptQuantity: '收货数量',//收货数量
    costPrice: '成本单价',//成本单价
    settlementUnitPrice: 'Đơn giá quyết toán',//结算单价
    farmingBatch: '养殖批次',//养殖批次
    plannedDateOfSeedling: '计划进苗日期',//计划进苗日期
    pleaseSelectBreedingBatch: '请选择养殖批次',//请选择养殖批次
    growerName: 'Tên hộ chăn nuôi',//养户名称
    technician: ' 技术员',// 技术员
    contractID: '合同号',//合同号
    settlementAmount: 'Số tiền quyết toán',//结算金额
    detailPrimaryKey: '明细主键',//明细主键
    contractCode: ' 合同编码',// 合同编码
    cooperationMode: '合作模式',//合作模式
    dateOfSigning: 'ngày kí hợp đồng',//签订日期
    effectiveDate: ' 生效日期',// 生效日期
    auditStatus: ' 审核状态',// 审核状态
    businessType: '业务类型',//业务类型
    businessItem: '业务项目',//业务项目
    expenseAmount: '费用金额',//费用金额
    auditStatus: '审核状态',//审核状态
    unitPrice: '单价',//单价
    materialCategory: '物料类别',//物料类别
    materialNumber: '物料编号',//物料编号
    materialName: '物料名',//物料名
    specification: 'Quy cách',//规格
    unit: 'Đơn vị',//单位
    amount: '金额',//金额
    bookkeepingDate: '记账日期',//记账日期
    contracName: '合同名称',//合同名称
    batchNumber: '批次编号',//批次编号
    batchName: 'Tên lô',//批次名称
    feedingCycle: '饲养周期',//饲养周期
    plannedNumberOfChicks: '计划入雏数量',//计划入雏数量
    documentNo: 'Số chứng từ',//单据编号
    batchNo: '养殖批次',//养殖批次
    qtyRequested: '申请数量',//申请数量
    plannedPlacementDate: '计划进苗日期',//计划进苗日期
    dateOfDemand: 'Ngày yêu cầu',//需求日期
    receivedQty: '收货数量',//收货数量
    unitNo: '单位编号',//单位编号
    costUnitPrice: '成本单价',//成本单价
    storageType: ' 入库类型',// 入库类型
    serviceDepartment: ' 服务部',// 服务部
    date: '日期',//日期
    chickenPrice: ' 成鸡价格',// 成鸡价格
    materialCommonName: '物料通用名',//物料通用名
    model: '型号',//型号
    unitOfMeasurement: '计量单位',//计量单位
    validOrNot: 'Có hiệu quả không',//是否有效
    contracts: '合同',//合同
    lastApprovalTime: '最后审批时间',//最后审批时间
    lastApproval: '最后审批人',//最后审批人
    reviewStatus: '审核状态',//审核状态
    securityDepositOperation: '保证金操作',//保证金操作
    businessDate: '业务日期',//业务日期
    operationTime: '操作时间',//操作时间
    batch: '批次',//批次
    batchSize: '批次规模',//批次规模
    placementQty: '入雏数量',//入雏数量
    currentStock: '当前存栏数',//当前存栏数
    reasonForApplication: '申请原因',//申请原因
    dateOfApplication: '申请日期',//申请日期

    applicationType: '申请类型',//申请类型
    totalAmount: '金额合计',//金额合计
    accountDate: '记账日期',//记账日期
    applicationInitiationDate: '申请发起日期',//申请发起日期
    cooperationModel: '合作模式',//合作模式
    partyBDividendRatio: '乙方分红比例',//乙方分红比例
    marketPrice: '市场价格',//市场价格
    exceedingPrice: '超出价格',//超出价格
    stocker: '放养员',//放养员
    stockerInCharge: '放养负责人',//放养负责人
    totalWeight: '出栏总重量',//出栏总重量
    dividendAmount: '分红金额',//分红金额
    accountOfTheBank: '开户行账户', // 开户行账户
    dividendPrice: '分红价格',//分红价格
    contractName: '合同名称',//合同名称
    cooperationMode: '合作模式',//合作模式
    contractType: '合同类型',//合同类型
    dateOfContractSigning: '合同签订日期',//合同签订日期
    contractEffectiveDate: '合同生效日期',//合同生效日期
    contractTerminationDate: '合同终止日期',//合同终止日期
    placeOfSigning: '签订地点',//签订地点
    sector: '部门',//部门
    enteredBy: '录入人',//录入人
    conversionRate: 'Conversion rate',//折本汇率
    fosterCareAdministrator: '养户管理员',//养户管理员
    serviceGroup: '服务组',//服务组
    contractVersion: '合同版本',//合同版本
    breederAdministrator: '养户管理员',//养户管理员
    localCurrency: '本位币',//本位币
    currency: '币种',//币种
    industry: '行业',//行业
    partyB: '乙方养户',//乙方养户
    partyA: '甲方公司',//甲方公司
    applicationInitiationTime: '申请发起时间',//申请发起时间
    mainUnitOfMeasurement: '主计量单位',//主计量单位
    fileCode: '档案编码',//档案编码
    fileDescription: '档案描述',//档案描述
    affiliateCategory: '关联类别',//关联类别
    costItemClassificationCode: '费用项分类编码',//费用项分类编码
    costItemClassification: '费用项分类',//费用项分类
    costItems: '成本项目',//成本项目
    diseaseFileCode: '疾病档案编码',//疾病档案编码
    diseaseCategory: '疾病类别',//疾病类别
    diseaseFileDescription: '疾病档案描述',//疾病档案描述
    associatedDiseaseCategories: '关联疾病类别',//关联疾病类别
    diseaseDescription: '疾病说明',//疾病说明
    symptomProfileCodes: '症状档案编码',//症状档案编码
    symptomProfileName: '症状档案名称',//症状档案名称
    fileType: '档案类型',//档案类型
    symptomFileDescription: '症状档案描述',//症状档案描述
    treatmentPlanName: '治疗方案名称',//治疗方案名称
    treatmentPlanDescription: '治疗方案描述',//治疗方案描述
    organsAnatomyFileCode: '脏器解剖档案编码',//脏器解剖档案编码
    anatomyFileName: '脏器解剖档案名称',//脏器解剖档案名称
    visceralAnatomyFileType: '脏器解剖档案类型',//脏器解剖档案类型
    organDissectionClassification: '脏器解剖分类',//脏器解剖分类
    descriptionOfTheOrganDissectionFile: '脏器解剖档案描述',//脏器解剖档案描述
    inspectionSubcategoryCode: '巡检小类编码',//巡检小类编码
    descriptionOfInspectionSubcategory: '巡检小类描述',//巡检小类描述
    inspectionCategory: '巡检大类',//巡检大类
    inspectionSubCategoryNumber: '巡检小类编号',//巡检小类编号
    nameOfInspectionCategory: '巡检小类名称',//巡检小类名称
    recurringIndicatorFileNumber: '循环指标档案编号',//循环指标档案编号
    circularIndicatorFileName: '循环指标档案名称',//循环指标档案名称
    breedingCategory: '饲养品类',//饲养品类
    feedingStage: '饲养阶段',//饲养阶段
    survivalRate: '成活率',//成活率
    averageWeightOfAdultChickens: '成禽均重',//成鸡均重
    feedingAmount: '喂料量',//喂料量
    realMeatRatio: '真实料肉比',//真实料肉比
    regularRatio: '常规料肉比',//常规料肉比
    serviceCompanyGuaranteePoint: '服务公司保本点',//服务公司保本点
    seedlingPriceToMeatRatio: '种苗价肉比',//种苗价肉比
    feedToMeatRatio: '饲料价肉比',//饲料价肉比
    vaccinePriceToMeatRatio: '疫苗价肉比',//疫苗价肉比
    healthCareMedicinePriceToMeatRatio: '保健药价肉比',//保健药价肉比
    treatmentMedicinePriceToMeatRatio: '治疗药价肉比',//治疗药价肉比
    priceToMeatRatioForPayingFarmers: '支付养户成本价肉比',//支付养户成本价肉比
    fileName: '档案名称',//档案名称
    standardCycleIndicatorNumber: '标准循环指标编号',//标准循环指标编号
    standardCycleIndicatorName: '标准循环指标名称',//标准循环指标名称
    pleaseEnterTheFileName: '请输入档案名称',//请输入档案名称
    chickenInspectionCode: '鸡苗检查编码',//鸡苗检查编码
    descriptionOfChickenInspection: '鸡苗检查描述',//鸡苗检查描述
    addressOnly: '地址', // 地址
    phoneNumber: '电话', // 电话
    symptomCategory: '症状类别',//症状类别
    descriptionOfTheOrganDissectionFile: '脏器解剖档案描述',//脏器解剖档案描述
    associatedDiseaseDescription: '关联疾病说明',//关联疾病说明
    symptomProfile: '症状档案',//症状档案
    symptomName: '症状名称',//症状名称
    symptomDescription: '症状说明',//症状说明
    visceralAnatomyProfile: '脏器解剖档案',//脏器解剖档案
    organAnatomyName: '脏器解剖名称',//脏器解剖名称
    organAnatomyDescription: '脏器解剖说明',//脏器解剖说明
    treatmentPlanFile: '治疗方案档案',//治疗方案档案
    treatmentProtocolName: '治疗方案名称',//治疗方案名称
    treatmentProtocolDescription: '治疗方案说明',//治疗方案说明
    symptomCategory: '症状类别',//症状类别
    symptomProfileDescription: '症状档案描述',//症状档案描述
    treatmentPlanCode: '治疗方案编码',//治疗方案编码
    treatmentPlanDescription: '治疗方案描述',//治疗方案描述
    organsAnatomyCategory: '脏器解剖类别',//脏器解剖类别
    descriptionOfTheOrganAutopsyFile: '脏器解剖档案描述',//脏器解剖档案描述
    planToRelease: '计划出栏',//计划出栏
    averageWeight: '均重', // 均重
    auxiliaryQuantity: '辅助数量',//辅助数量
    building: '栋舍', // 栋舍
    giveaway: '赠品',//赠品
    operator: '操作人', // 操作人
    roundingDate: '入舍日期',//入舍日期
    species: '品种',//品种
    settlementDate: '结算日期',//结算日期
    highestPrice: 'Highest Price',//最高价
    minimumPrice: 'Minimum price',//最低价
    numberOfSlaughtered: '出栏羽数',//出栏羽数
    weightOfSlaughter: '出栏重量(kg)',//出栏重量(kg)
    averagePigeonWeight: '平均羽重(kg/羽)',//平均羽重(kg/羽)
    amountOfRecovery: '回收金额',//回收金额
    placementDate: '进鸡日期',//进鸡日期
    transferOutDepartment: '转出部门',//转出部门
    transferToDepartment: '转入部门',//转入部门
    materialSettlementPrice: '物资结算价格',//物资结算价格
    lastApprover: '最后审批人',//最后审批人
    method: '方式',//方式
    effectiveTime: '生效时间',//生效时间
    category: '品类', // 品类
    productCostAccountCode: 'Prod. Cost Acc. Code', // 生产成本科目代码
    productCostAccountName: 'Prod. Cost Acc. Name', // 生产成本科目名称
    inventoryAccountCode: 'Inventory Acc. Code', // 库存科目代码
    inventoryAccountName: 'Inventory Acc. Name', // 库存科目名称
    salesCostAccountCode: 'Sales Cost Acc. Code', // 销售成本科目编号
    salesCostAccountName: 'Sales Cost Acc. Name', // 销售成本科目名称
    yonghumingcheng: '用户名称t', // 用户名称
    ruleType: 'Kiểu quy', // 规则类型
    RuleValueFormat: 'Định dạng giá trị quy', // 规则值格式
    fillRule: 'Điều luật điền', // 填充规则
    fillChar: 'Điền ký tự', // 填充字符
    length: 'dài', // 长度
    sex: 'Giới' // 性别
  },
  button: {
    executeImmediately: 'Hành động ngay', //立即执行
    zidianpeizhi: 'Dict Config', //字典配置
    confirm: 'Đảm bảo',//确定
    search: 'Tra cứu',//查询
    reset: 'Cài lại',//重置
    add: 'Tăng mới',//新增
    import: 'Nhập',//导入
    detailImport: 'Detail Upload',//明细导入
    quickInput: 'Quickly Input',//快读录入
    export: 'Xuất',//导出
    edit: 'Chỉnh sửa',//编辑
    more: 'Xem thêm',//更多
    delete: 'Xóa bỏ',//删除
    clear: 'Quét sạch, loại bỏ',//清空
    batchOperation: 'Thao tác hàng loạt',//批量操作
    cancel: 'Hủy bỏ',//取消
    details: 'Chi tiết.',//详情
    password: 'mật khẩu',//密码
    frozen: 'đóng băng',//冻结
    thaw:'tan',//解冻
    submit: 'Giao',//提交
    writeOff: 'Viết tắt',//冲销
    synchronize: 'Đồng bộ',//同步
    print: 'In',//打印
    save: 'Lưu',//保存
    close: 'Khép kín',//关闭
    select: 'Lựa chọn',//选择
    addByReference: '参照新增',//参照新增
    orderSelection: 'Trình đơn',//选单
    initializeImport: 'Nhập lần đầu',//初始化导入
    forDetailsPlease: '具体详情请',//具体详情请
    clickToDownload: 'Nhấn vào tải',//点击下载
    logOut: 'Đăng xuất',//退出登录
    enable: 'Cho phép sử dụng',//启用
    disable: 'Ngăn chặn/ cấm',//禁用
    extractionCompanyDetails: 'Trích xuất chi tiết công ty',//提取公司明细
    addCompany: 'Thêm Công ty',//添加公司
    addSubordinate: 'Thêm cấp dưới',//添加下级
    releaseVersion: 'Phiên bản phát hành',//发布版本
    batchDelete: 'Xóa hàng loạt',//批量删除
    treeOperations: 'Thao tác dọc',//树操作
    FatherSonConnection: 'Quan hệ huyết thống',//父子关联
    cancelConnection: 'Hủy bỏ liên kết',//取消关联
    selectAll: 'Rà soát tất cả',//全部勾选
    unselectAll: 'Hủy bỏ tất cả',//取消全选
    expandAll: 'Mở rộng sở hữu',//展开所有
    mergeAll: 'Hợp nhất tất cả',//合并所有
    newRole: 'Vai trò mới',//新建角色
    newDepartRole: 'Vai trò mới của bộ', // 新建部门角色
    clearSelection: 'Xóa lựa chọn',//清空选择
    batchRestore: 'Khôi phục hàng loạt',//批量还原
    restoreUser: 'Khôi phục người dùng',//还原用户
    deleteCompletely: 'Xóa hết',//彻底删除
    existingUsers: 'Đã có người dùng',//已有用户
    authorization: 'Ủy quyền',//授权
    saveOnly: 'Chỉ lưu lại',//仅保存
    saveAndClose: '保存并关闭',//保存并关闭
    dataRules: 'Quy tắc số liệu',//数据规则
    approve: '审批',//审批
    turnDown: '驳回',//驳回
    void: '作废',//作废
    approval: '审批',//审批
    voided: '作废',//作废
    copy: 'Coppy',//复制
    rejected: '驳回',//驳回
    reviewApproved: '审核通过',//审核通过
    sync: 'Đồng bộ',//同步
    update: '更新',//更新
    withdraw: '撤回',//撤回
    synchronousUpdate: '同步更新',//同步更新
    statistics: '统计',//统计
    drawDownContractPriceList: '提取合同价格清单',//提取合同价格清单
    newFarm: '新增养殖场',//新增养殖场
    detailImport: '明细导入',//明细导入
    refreshTheCache: '刷新缓存',//刷新缓存
    recycleBin: '回收站',//回收站
    customQuery: '高级查询',//高级查询
    notice: '通知P',//通知
    systemMessage: '系统消息P',//系统消息
    seeMore: '查看更多P',//查看更多
    next: 'Next',//下一步
    previous: 'Previous',//上一步
    execute: 'Execute',//执行
    release: 'tháo',//发布
    revoke: 'thu',//撤销
    see: 'xem'//查看
  },
  tip: {
    queDingFaBuMa: 'Bạn có chắc sẽ xuất bản',
    queDingCheXiaoMa: 'Bạn có chắc sẽ hủy',
    zuihouyiye: 'This is the last page. You can not close it anymore',//这是最后一页，不能再关闭了啦
    shouyebunengguanbi: 'Home page cannot be closed',//首页不能关闭
    loginTitle: 'Đăng nhập mật khẩu tài khoản',//账号密码登陆
    dragVerify: 'Kéo để xác minh',//拖动滑块验证
    dragSuccess: 'Thông qua xác nhận',//验证通过
    automaticLogin: 'Đăng nhập tự động',//自动登陆
    pleaseInput: 'Mời nhập',//请输入
    pleaseSelect: 'Mời lựa chọn',//请选择
    confirmDeletion: 'Xác nhận xóa',//确认删除
    deleteTheSelectedData: 'Bạn có chắc muốn xóa số liệu đã lựa chọn hay không?',//是否删除选中数据?
    selected: 'Đã được chọn',//已选择
    term: '项',//项
    up: 'Thu lại',//收起
    down: 'Mở rộng',//展开
    total: 'Tổng cộng',//共
    article: '条',//条
    pleaseSet: 'Mời cài đặt',//请设置
    isSubmit: 'Bạn có chắc muốn giao nộp không?',//确认提交吗?
    isWriteOff: 'Bạn có chắc muốn loại bỏ giá trị này không?',//确定冲销吗?
    isDelete: 'Chắc chắn xóa không',//确定删除吗?
    isSynchronize: 'Bạn có chắc muốn đồng bộ không?',//确定同步吗?
    isCancel: 'Bạn có chắc hủy không?',//确定取消吗?
    isEnable: 'Bạn có chắc kích hoạt nó?',//确定启用吗?
    isDisable: 'Bạn có chắc tắt không?',//确定禁用吗?
    mustBeGreaterThan0: 'Bắt buộc lớn hơn 0',//必须大于0
    mustBeGreaterThanOrEqualToZeroInteger: 'Số nguyên lớn hơn hoặc bằng 0',//必须为大于等于零整数
    mustBeAPositiveInteger: 'Phải là số nguyên dương',//必须为正整数
    mustBeAnInteger: 'Phải là Số nguyên',//必须为整数
    filledInUpTo10Characters: 'Điền vào tối đa 10 ký tự',//最多填写10个字符
    cannotBeEmpty: 'Không để trống',//不能为空
    mustBeLessThanOneDecimalPlaces: 'Nhỏ hơn 1 chữ số thập phân',//必须少于一位小数
    mustBeLessThanTwoDecimalPlaces: 'Nhỏ hơn 2 chữ số thập phân',//必须少于两位小数
    mustBeLessThanThreeDecimalPlaces: 'Số lượng nhập kho bắt buộc ít hơn ba chữ số thập phân',//入库数量必须少于三位小数
    mustBeAPositiveFntegerFrom1To12: '1-12 số nguyên dương',//必须为1-12正整数
    pleaseFillInTheInformationCompletely: 'Vui lòng điền đầy đủ thông tin!',//请将信息填写完整！
    successfulOperation: 'Thao tác thành công',//操作成功
    noData: 'Không có dữ liệu',//暂无数据
    fileUploadSuccessful: 'Tải tệp lên thành công',//文件上传成功
    fileUploadFailed: 'Tệp không tải lên được',//文件上传失败
    none: 'Không có',//无
    addAtLeastOneItemizedQuantity: 'Thêm ít nhất một số lượng chi tiết!',//至少添加一条明细的数量！
    confirmSubmission: 'Xác nhận giao nộp',//确认提交
    whetherToSubmitTheSelectedData: 'Bạn có chắc muốn giao nộp số liệu đã lựa chọn hay không?',//是否提交选中数据
    tips: 'Gợi ý.',//提示
    YouDoNotBelongToTheDepartmentPleaseConfirmTheAccountInformation: '您尚未归属部门，请确认账号信息',//您尚未归属部门，请确认账号信息
    currentOrganizationalStructureWillBeDocumented: 'Cơ cấu tổ chức được ghi lại',//发布版本的同时会将当前组织架构进行记录
    importantOperations: 'Thao tác quan trọng',//重要操作
    pleaseSelectDepartmentFirst: 'Xin mời chọn trước một bộ phận',//请先选择一个部门
    areYouSureYouWantToLogOff: 'Bạn thật sự muốn đăng xuất?',//真的要注销登录吗?
    error: 'Sai lầm',//错误
    refreshCacheCompleted: 'Hoàn thành làm mới bộ nhớ!',//刷新缓存完成！
    failedToRefreshCache: 'Làm mới bộ nhớ thất bại!',//刷新缓存失败！
    sureToAbandonEditing: 'Bạn có chắc muốn từ bỏ việc chỉnh sửa không?',//确定放弃编辑？
    restoreUser: 'Khôi phục người dùng',//恢复用户
    areYouSureRestore: '您确定要恢复',//您确定要恢复
    users: 'Người sử dụng',//用户
    deleteCompletely: 'Xóa hết',//彻底删除
    areYouSureDelete: 'Ngài muốn xóa hoàn toàn',//您确定要彻底删除
    notePleaseBeCarefulItCannotBeRecoveredAfterDeletion: '注意：彻底删除后将无法恢复，请谨慎操作！',//注意：彻底删除后将无法恢复，请谨慎操作！
    restore: 'Khôi phục',//还原
    delete: 'Xóa bỏ',//删除
    successfully: 'Thành công',//成功
    yourPhoneNumberIncorrect: 'Số điện thoại của ngài không hợp lệ',//您的手机号码格式不正确
    currentSelection: 'Lựa chọn hiện tại',//当前选择
    orgCodeAlreadyExists: 'Mã tổ chức đã tồn tại',//机构编码已存在
    pleaseSelectARecord: 'Vui lòng chồng một nội dung ghi chép',//请选择一条记录
    pleaseChooseToModify: 'Bấm chọn sửa đổi bộ phận',//请点击选择要修改部门
    failureOperation: 'Thao tác thất bại',//操作失败
    areYouSureDeleteDepartmentAndSubData: 'Bạn có chắc muốn xóa bỏ bộ phần này và số liệu kèm theo không?',//确定要删除此部门以及子节点数据吗
    pleaseSelectParentDepartment: 'Xin mời click chọn bộ phận trung/ cao tầng',//请先点击选中上级部门
    dataAndSubData: '条数据，以及子节点数据吗?',//条数据，以及子节点数据吗?
    confirmTheApproval: '确认审核通过',//确认审核通过
    determineThePlanToReject: '确定计划驳回',//确定计划驳回
    determinedToVoid: '确定作废',//确定作废
    details: ' 详情',// 详情
    mustBeGreaterThanOrEqualTo: '必须大于等于0',//必须大于等于0
    mustBeLessThanFourDecimalPlaces: '必须少于四位小数',//必须少于四位小数
    mustBeLessThanSixDecimalPlaces: '必须少于六位小数',//必须少于六位小数
    mustBeOrPositiveInteger: '必须是或者正整数',//必须是或者正整数
    rejected: '确定驳回',//确定驳回
    contractBreakdownSheetFailedTo: '合同明细表单校验未通过',//合同明细表单校验未通过
    confrimSynchronization: '确定同步',//确定同步
    makeSureTheReviewIsApproved: '确定审核通过',//确定审核通过
    confirmRejection: '确定计划驳回',//确定计划驳回
    confirmToVoid: '确定作废',//确定作废

    okToUpdateTheStatement: '确定更新结算单',//确定更新结算单
    okToWithdraw: '确定撤回吗',//确定撤回吗
    theHighestPriceCannotBeLessThanTheLowestPrice: '最高价不能小于最低价',//最高价不能小于最低价
    lowestPriceCannotBeGreaterThanTheHighestPrice: '最低价不能大于最高价',//最低价不能大于最高价
    mustBe0OrAPositiveInteger: '必须为0或正整数',//必须为0或正整数
    theDataIsNotFilledInCompletelyPleaseCheck: '数据没有填完整,请检查',//数据没有填完整,请检查
    theBatchDoesNotHaveTheDeliveryInformation: '该批次没有出栏信息',//该批次没有出栏信息
    noConsumptionInformationForThisBatch: '该批次没有耗用信息',//该批次没有耗用信息
    theVerificationOfTheBatchDetailsDidNotPass: '出栏明细校验未通过',//出栏明细校验未通过
    feedingBatchNeedsToBeSelected: '饲养批次需要选择',//饲养批次需要选择
    marginFormCheckFailed: '保证金表单校验未通过',//保证金表单校验未通过
    departmentSwitching: '部门切换P',//部门切换
    currentDepartment: '当前部门P',//当前部门
    pleaseSelectSettlementBatchNumber: 'Hãy chọn số nguyên mẫu'//请选择结算批次编号
  },
  tabName: {
    detailOfTheBill: 'Chi tiết tài liệu',//单据明细
    EggStockInDetails: 'Trang trứng theo chi tiết', // 种蛋入库明细
    purchaseOrder: 'Đơn vị đặt hàng',//采购订单
    purchaseOrderDetails: 'Chi tiết đơn đặt hàng',//采购订单明细
    openOrders: 'Đơn đặt hàng còn tồn đọng',//未清订单
    orderDetails: 'Chi tiết đơn hàng',//订单明细
    outgoingDetails: 'Chi tiết xuất hàng',//出库明细
    inboundDetails: 'Chi tiết nhập kho',//入库明细
    transferDetails: 'Phân bổ chi tiết',//调拨明细
    eggCollectionDetails: 'Chi tiết thu trứng',//收蛋明细
    regular: 'Thông thường',//常规
    price: 'Giá trị ban đầu',//身价
    entryDetails: 'Chi tiết nhập chuồng',//入舍明细
    feedingDetails: 'Chi tiết cho ăn',//饲喂明细
    immunizationAndMedicationDetails: 'Miễn dịch và chi tiết dùng thuốc',//免疫及用药明细
    mortality: 'Chết loại thải',//死淘
    eggProduction: '蛋品入库',//蛋品入库
    cull: 'Xuất chuồng',//出栏
    selectCulling: 'Đăng kí chọn thải',//选淘登记
    selectCullingDetails: 'Chi tiết đăng kí chọn thải',//选淘登记明细
    registrationDetailsOfSlaughterhouse: '出栏登记明细',//出栏登记明细
    transferOutDetails: 'Chi tiết chuyển đi',//转出明细
    transferInDetails: 'Chi tiết chuyển đến',//转入明细
    breakdownOfHerd: 'Chi tiết nhóm',//分群明细
    testCollectionDetails: 'Chi tiết lĩnh dùng thử nghiệm',//试验领用明细
    weightBreakdown: 'Cân nặng chi tiết',//体重明细
    weeklyPlanDetail: 'Chi tiết kế hoạch tuần',//周计划明细
    deadAmoyDetail: 'Chi tiết loại thải/ chết',//死淘明细
    egg: 'soi trứng',//照蛋
    dropTray: 'Đặt hàng',//落盘
    hatching: 'Ấp trứng',//出雏
    feedingStandardDetails: 'Chi tiết tiêu chuẩn thức ăn',//饲喂标准明细
    vaccinationStandardDetails: 'Tiêu chuẩn miễn dịch chi tiết',//免疫标准明细
    antibodyStandardDetails: 'Chi tiết tiêu chuẩn kháng thể',//抗体标准明细
    environmentalStandards: 'Tiêu chuẩn môi trường',//环境标准
    rearingPeriod: 'Kỳ hạn chăn nuôi',//饲养期
    feedingStandards: 'Tiêu chuẩn thức ăn',//饲喂标准
    immunizationStandards: 'Tiêu chuẩn miễn dịch',//免疫标准
    medicationStandard: 'Tiêu chuẩn thuốc',//用药标准
    incubationDetails: 'Chi tiết quá trình ấp',//上孵明细
    recheckDetails: 'Kiểm tra chi tiết',//复检明细
    detailsOfEggsAndFallingPlates: 'Chi tiết soi trứng và đặt vào khay',//照蛋及落盘明细
    hatchingDetails: 'Chi tiết ấp',//出雏明细
    lowConsumptionDetails: '低耗明细',//低耗明细
    breedingStandard: 'Tiêu chuẩn chăn nuôi',//养殖标准
    securityDeposit: 'Tiền cọc',//保证金
    materialSettlementPrice: '物资结算价格',//物资结算价格
    fees: 'chi phí',//费用
    subsidy: 'Phụ cấp',//补贴
    recoveryPrice: '回收价格',//回收价格
    recoverySettlement: '回收结算',//回收结算
    remarks: 'Ghi chú',//备注
    priceList: 'Danh sách giá cả',//价格清单
    feedDetail: '饲料明细',//饲料明细
    detailsOfTheMove: '动保明细',//动保明细

    materialDetails: '物料明细',//物料明细
    contractPriceListDetails: '合同价格清单详情',//合同价格清单详情
    symptoms: '症状',//症状
    visceralAnatomy: '脏器解剖',//脏器解剖
    treatmentOptions: '治疗方案',//治疗方案
    inspectionItem: '巡检项',//巡检项
    consumptionInformation: '耗用信息',//耗用信息
    subsidyItem: '补贴项',//补贴项
    expenseItem: '费用项',//费用项
    penalty: '惩罚项',//惩罚项
    settlement: '结算',//结算
    consumptionSummary: '耗用汇总',//耗用汇总
    columnSummary: '出栏汇总',//出栏汇总
    marginRecord: '保证金记录',//保证金记录
    materialConversionDetails: '物料转换明细',//物料转换明细
    eggStorage: '蛋品入库(换羽)',//蛋品入库(换羽)
    receipt: '领用',//领用
    requisitionStatistics: '领用统计'//领用统计
  },
  systemBase: {
    title: 'Hệ thống nông trại thông minh',//动物管理系统
    company: 'Công ty TNHH Khoa học kĩ thuật nông nghiệp chăn nuôi Tập Trí Thượng Hải',//上海楫智牧业科技有限公司
    help: 'Giúp đỡ',//帮助
    privacy: 'Riêng biệt',//隐私
    clause: 'Điều khoản',//条款
    produce: 'Sản xuất',//出品
    welcome: 'Hoan nghênh ngài',//欢迎您
    welcomeBack: 'Hoan nghênh trở lại',//欢迎回来
    welcomeToTheSmartFarmSystem: 'Hoan nghênh sử dụng hệ thống trang trại thông minh',//欢迎使用动物管理系统
    currentEnvironmentIs: 'Môi trường hiện tại',//当前环境为：
    currentLoginCompanyIs: 'Công ty hiện đã đăng ký:',//当前登录公司为：
    searchMenu: 'Danh mục cần tìm',//搜索菜单
    systemSettings: 'Cài đặt hệ thống',//系统设置
    changePassword: 'Đổi mật khẩu',//密码修改
    switchDepartment: 'Chuyển đổi bộ phận',//切换部门
    cleanCache: 'Dọn dẹp bộ nhớ',//清理缓存

    goodMorning: '上午好',//上午好
    goodMornings: '早上好',//早上好
    goodAfternoon: '中午好',//中午好
    goodAfternoons: '下午好',//下午好
    goodEvening: '晚上好',//晚上好
    languageSwitching: '语言切换',//语言切换
    mainLanguage: '主语言P',//主语言
    subLanguage: '次语言P',//次语言
    overallStyleSetting: '整体风格设置P',//整体风格设置
    darkMenuStyle: '暗色菜单风格P',//暗色菜单风格
    brightMenuStyle: '亮色菜单风格P',//亮色菜单风格
    themeColor: '主题色P',//主题色
    navigationMode: '导航模式P',//导航模式
    sidebarNavigation: '侧边栏导航P',//侧边栏导航
    topBarNavigation: '顶部栏导航P',//顶部栏导航
    topBarNavigationTip: '该设定仅 [顶部栏导航] 时有效P',//该设定仅 [顶部栏导航] 时有效
    fixed: '固定P',//固定
    flowType: '流式P',//流式
    contentAreaWidth: '内容区域宽度P',//内容区域宽度
    fixedHeader: '固定 HeaderP',//固定 Header
    hideHeaderWhenSliding: '下滑时隐藏 HeaderP',//下滑时隐藏 Header
    fixedSideMenu: '固定侧边菜单P',//固定侧边菜单
    otherSettings: '其他设置P',//其他设置
    colorWeakMode: '色弱模式P',//色弱模式
    multiTabMode: '多页签模式P',//多页签模式
    settingTips: '配置栏只在开发环境用于预览，生产环境不会展现，请手动修改配置文件P',//配置栏只在开发环境用于预览，生产环境不会展现，请手动修改配置文件
    home: 'Home',//首页
    shuaxin: 'reload tab',//刷新
    guanbizuoce: 'close tabs to left',//关闭左侧
    guanbiyouce: 'close tabs to right',//关闭右侧
    guanbiqita: 'close other tabs'//关闭其他
  },
  modalTitle: {
    addExistingUser: 'Thêm vào người dùng vốn có',//添加已有用户
    newAddUser: 'Người dùng mới',// 新建用户
    rolePermissionsConfiguration: 'Cài đặt quyền hạn vai trò',//角色权限配置
    departmentPermissionConfiguration: 'Cấu hình cơ quan chức năng',//部门权限配置
    addSubmenu: 'Thêm vào danh mục con',//添加子菜单
    dataPermissionRules: 'Quy tắc quyền hạn số liệu'//数据权限规则
  }
}
